<template>
  <div>
    <div class="header">
      <div class="header-info-container">
        <HeaderInfoPanel :user-data="userData"/>
      </div>
    </div>

    <div class="top-buttons-container" style="z-index: 9999">
      <div class="left-buttons">
        <button
            class="top-button"
            v-for="(btn, index) in leftButtons"
            :key="`left-${index}`"
            :style="{ backgroundImage: `url(${buttonIcon4})` }"
            @click="handleButtonClick(btn.label)"
        >
          {{ btn.label }}
        </button>
      </div>
      <div class="right-buttons">
        <button
            class="top-button"
            v-for="(btn, index) in rightButtons"
            :key="`right-${index}`"
            :style="{ backgroundImage: `url(${buttonIcon3})` }"
            @click="handleButtonClick(btn.label)"
        >
          {{ btn.label }}
        </button>
      </div>
    </div>

    <div id="cesiumContainer"></div>

    <LocationSelector ref="LocationSelector"/>

    <div>
      <div v-if="false && showChat" style="position:absolute; width:50%; height:600px;left: 25%;top: 160px">
        <iframe src="https://www.codeluo.cn/bot/index.html#/1/1972649911273476097/chat"
                style="width: 100%; height: 100%; border: none;"
                allow="microphone">
        </iframe>
      </div>

      <button
          class="chatbot"
          @click="toggleChat"
      >
        <svg xmlns="http://www.w3.org/2000/svg"
             width="28" height="28" viewBox="0 0 24 24"
             fill="white">
          <path
              d="M12 2a2 2 0 0 1 2 2v1h2.5a1.5 1.5 0 0 1 0 3H18v2h1a3 3 0 0 1 3 3v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7a3 3 0 0 1 3-3h1V8h1.5a1.5 1.5 0 0 1 0-3H10V4a2 2 0 0 1 2-2zm-4 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
        </svg>
      </button>

      <div class="bottom-dock">
      <button
          class="bottom-button"
          @click="openStorylineGuide"
          style="left: 20%;"
      >
        <span style="margin-left: 8px;font-size: 14px">演示导览</span>
      </button>

      <button
          class="bottom-button"
          @click="showComprehensiveMonitoring"
          style="left: 35%;"
      >
        <span style="margin-left: 8px;font-size: 14px">综合监控</span>
      </button>

      <button
          class="bottom-button"
          @click="showWaterSupplyScale"
          style="left: 50%;"
      >
        <span style="margin-left: 8px;font-size: 14px">供水规模</span>
      </button>

      <button
          class="bottom-button"
          @click="showWaterDistributionLines"
          style="left: 65%;"
      >
        <span style="margin-left: 8px;font-size: 14px">运行调度</span>
      </button>
      </div>

    </div>

    <SubmergAnalysis
        ref='child'
        class="submergence-floating-panel"
        v-show="adjustVisible"
        @back='back'
                 @openEmergencyPlan="openEmergencyPlan"
                 @openTaskExecution="openEmergencyTaskExecution"
        @close="endSubmergence">
    </SubmergAnalysis>

    <left-board v-if="panels.showLeftBoard"
                @flyRing="flyRing"
                @openLeftCard="openLeftCard"
    ></left-board>

    <right-board
        v-if="panels.showRightBoard"
        @addModel="addModel"
        @doDispatch="doDispatch"
        @changeScheme="changeScheme"
    ></right-board>

    <MulSchemes
        ref="mulSchemes"
        v-if="mulSchemesVisible"
        @changeScheme="changeScheme"
        @nextChange="nextChange">
    </MulSchemes>

    <div
        v-if="panels.currentComp"
        :class="['panel-host', panelLayoutClass]"
    >
      <div v-if="false" class="smartorb-handoff">
        <div class="handoff-orb"></div>
        <div class="handoff-copy">
          <span>古贤智能助手已接入当前模组</span>
          <strong>{{ smartOrbHandoffText }}</strong>
        </div>
      </div>
      <component :is="panels.currentComp"
                 class="managed-panel"
                 v-bind="panels.currentProps"
                 @close="panelStore.close()"
                 @infoClose="panelStore.close()"
                 @adjust="adjust"
                 @conservation="conservation"
                 @customization="customization"
                 @nextChange="nextChange"
                 @initLevel="initLevel"
                 @changeScheme="changeScheme"
                  @openCalc="openCalc"
                  @openSupplyDemand="openSupplyDemand"
                  @openDispatch="openDispatchFromSupply"
                  @openEmergencyPlan="openEmergencyPlan"
                 @flyToGis="flyToEmergencyGis"
                 @scenarioChanged="onEmergencyScenarioChanged"
                 @return="returnFromTaskExecution"
                 @openModule="openStoryModule"
                 @unbalance="goUnbalance"
                 @back="back" />
    </div>
  </div>
</template>

<script>
import {initCesium} from '../common/js/initCesium'
import SubmergAnalysis from "@/components/submergAnalysis.vue";
import Prolusion from "@/components/prolusion";
import leftBoard from "@/components/leftBoard.vue";
import rightBoard from "@/components/rightBoard.vue";
import DragEntity from "@/utils/dragentity";
import * as Cesium from 'cesium'
import Bubble from "@/utils/bubble";
import {
  BranchTrunkLine,
  building,
  buildingPipe,
  channel,
  district,
  FetchPipe,
  highTrunkLine,
  hyStations,
  industrialPark,
  irrigation,
  monitoring,
  pool,
  pumping,
} from '@/common/js/position'
import Custom from "@/components/custom.vue";
import {getFlylineMaterial} from "@/utils/flyLine";
import ProtectionInfo from "@/components/protectionInfo.vue";
import MulSchemes from "@/components/mulSchemes.vue";
import DynamicRange from "@/utils/dynamicRange";
import HightTrunkInfo from "@/components/hightTrunkInfo.vue";
import BranchTrunkInfo from "@/components/branchTrunkInfo.vue";
import Industrialinfo from "@/components/industrialinfo.vue";
import ReservoirInfo from "@/components/reservoirInfo.vue";
import CalcTable from "@/components/calcTable.vue";
import RegulatingReservoir from "@/components/regulatingReservoir.vue";
import PumpingInfo from "@/components/pumpingInfo.vue";
import PoolInfo from "@/components/poolInfo.vue";
import IrrigationInfo from "@/components/irrigationInfo.vue";
import HeaderInfoPanel from "@/components/HeaderInfoPanel.vue";
import LocationSelector from "@/components/LocationSelector.vue";
import CenterCard from "@/components/centerCard.vue";
import MonitoringLabel from "@/components/monitoringLabel.vue";
import OperationScheduling from "@/components/operationScheduling.vue";
import NoticeCard from "@/components/noticeCard.vue";
import SmartConstruction from "@/components/smartConstruction.vue";
import ProjectManagement from "@/components/projectManagement.vue";
import EmergencyManagement from "@/components/emergencyManagement.vue";
import OperationMaintenance from "@/components/operationMaintenance.vue";
import CardDetaile from "@/components/cardDetaile.vue";
import SupplyDemandPanel from './SupplyDemandPanel.vue'
import StorylineGuide from './StorylineGuide.vue'
import { WarningService } from '@/services/warningService.js'
import { listReservoirs } from '@/services/reservoirCatalog.js'
import { getActiveScenario, getActiveScenarioKey, getActiveScenarioInfo, switchScenario, listScenarios } from '@/services/emergencyMapData.js'
// 导入AI问答组件
import KnowledgeQA from "@/components/KnowledgeQA.vue";
import ConstructionSafetyQA from "@/components/ConstructionSafetyQA.vue";
// 导入运行调度AI问答组件
import OperationSchedulingQA from "@/components/OperationSchedulingQA.vue";

import { panelStore, register } from '@/panelStore.js'
import IrrigationControl from "@/components/IrrigationControl.vue";
import PoolControl from "@/components/PoolControl.vue";
import PumpingControl from "@/components/PumpingControl.vue";
import ReservoirControl from "@/components/ReservoirControl.vue";
import TaskExecutionPage from "@/components/competition/TaskExecutionPage.vue";

register('monitoring', MonitoringLabel)
register('waterSupply', CenterCard)
register('scheduling', OperationScheduling)
register('construction', SmartConstruction)
register('project', ProjectManagement)
register('emergency', EmergencyManagement)
register('maintenance', OperationMaintenance)
register('notice', NoticeCard)
register('floodSim', Prolusion)
register('submergence', SubmergAnalysis)
register('custom', Custom)
register('knowledgeQA', KnowledgeQA)
register('safetyQA', ConstructionSafetyQA)
register('schedulingQA', OperationSchedulingQA)
register('protection', ProtectionInfo)
register('industrial', Industrialinfo)
register('reservoir', ReservoirInfo)
register('reservoirInfo', ReservoirInfo)
register('regulating', RegulatingReservoir)
register('regulatingReservoir', RegulatingReservoir)
register('pumping', PumpingInfo)
register('pool', PoolInfo)
register('irrigation', IrrigationInfo)
register('hightTrunk', HightTrunkInfo)
register('branchTrunk', BranchTrunkInfo)
register('calcTable', CalcTable)
register('detaile', CardDetaile)
register('mulSchemes', MulSchemes)
register('irrigationCtrl', IrrigationControl)
register('poolCtrl', PoolControl)
register('pumpingCtrl', PumpingControl)
register('reservoirCtrl', ReservoirControl)
register('taskExecution', TaskExecutionPage)
register('supplyDemand', SupplyDemandPanel)
register('storyline', StorylineGuide)

export default {
  components: {
    LocationSelector,
    HeaderInfoPanel,
    MulSchemes,
    SubmergAnalysis,
    leftBoard,
    rightBoard,
  },
  data() {
    return {
      buttonIcon1: require('@/assets/buttonicon1.png'),
      buttonIcon2: require('@/assets/buttonicon2.png'),
      buttonIcon3: require('@/assets/buttonicon3.png'),
      buttonIcon4: require('@/assets/buttonicon4.png'),

      leftButtons: [
        {label: '任务网络'},
        {label: '运维管理'},
        {label: '应急管理'},
        {label: '工程管理'}
      ],

      rightButtons: [
        {label: '智能建造'},
        {label: '通知公告'}
      ],

      userData: {
        name: '管理员',
        role: '系统管理员'
      },

      panels: panelStore,
      panelStore: panelStore,

      // adjustVisible and mulSchemesVisible are intentionally kept as boolean flags
      // because SubmergAnalysis and MulSchemes need $refs access (cannot use dynamic component)
      adjustVisible: false,
      mulSchemesVisible: false,
      defend: [],
      info: {},
      layer: null,
      title: '供水规模统计',
      riverDataSource: null,
      lineEntity: [],
      emergency: false,
      showChat: false,
      poinEntity: {},
      reservoirRegistry: {},
      pipeObj: [],
      rangeList: [],
      emergencyGisEntities: [],
      cesiumViewer: null,
      warningMessageCache: {},
      assistantAnalysisLayers: {},
      options: [{
        type: '0',
        label: '取水方案'
      }, {
        type: '1',
        label: '供水方案'
      }],

      aiAssistantOpen: false,
      knowledgeQAVisible: false,
      currentAssistant: 'engineering'
    }
  },
  computed: {
    showSmartOrbHandoff() {
      const props = this.panels.currentProps || {}
      return props.source === 'smartOrb' && !!props.initialQuery && !['knowledgeQA', 'safetyQA', 'schedulingQA'].includes(this.panels.currentKey)
    },
    smartOrbHandoffText() {
      const props = this.panels.currentProps || {}
      return props.initialQuery || props.smartOrbHandoff?.query || '已从智能助手打开当前模组'
    },
    panelLayoutClass() {
      const key = this.panels.currentKey
      const workbench = ['monitoring', 'waterSupply', 'scheduling', 'construction', 'project', 'emergency', 'maintenance', 'notice', 'storyline']
      const inspector = ['protection', 'industrial', 'pumping', 'pool', 'irrigation', 'hightTrunk', 'branchTrunk', 'calcTable', 'detaile', 'mulSchemes']
      const qa = ['knowledgeQA', 'safetyQA', 'schedulingQA']
      if (key === 'storyline') return 'panel-layout-storyline'
      if (key === 'floodSim') return 'panel-layout-flood'
      if (key === 'scheduling') return 'panel-layout-scheduling'
      if (key === 'emergency') return 'panel-layout-emergency'
      if (key === 'knowledgeQA') return 'panel-layout-knowledge'
      if (key === 'taskExecution') return 'panel-layout-task-execution'
      if (key === 'custom') return 'panel-layout-right-dock'
      if (key === 'supplyDemand') return 'panel-layout-bottom-sheet'
      if (['reservoir', 'reservoirInfo', 'regulating', 'regulatingReservoir'].includes(key)) return 'panel-layout-reservoir-dual'
      if (workbench.includes(key)) return 'panel-layout-workbench'
      if (qa.includes(key)) return 'panel-layout-assistant'
      if (inspector.includes(key)) return 'panel-layout-inspector'
      return 'panel-layout-inspector'
    },
  },
  watch: {
    'panels.currentKey'(key) {
      if (key && key !== 'floodSim') {
        this.resetTransientScenePanels()
      }
      if (key === 'emergency') {
        const shouldFly = !!(this.panels.currentProps && this.panels.currentProps.flyToEmergency)
        this.$nextTick(() => this.renderEmergencyGisLayer({ fly: shouldFly }))
      }
      if (key === 'floodSim' && this.panels.currentProps && this.panels.currentProps.autoRunSchemeNum) {
        this.$nextTick(() => this.autoStartFloodPreview(this.panels.currentProps))
      }
    },
    'panels.currentProps'() {
      if (this.panels.currentKey === 'emergency') {
        const shouldFly = !!(this.panels.currentProps && this.panels.currentProps.flyToEmergency)
        this.$nextTick(() => this.renderEmergencyGisLayer({ fly: shouldFly }))
      }
    }
  },
  mounted() {
    this.cesiumViewer = initCesium()
    window.viewer = this.cesiumViewer
    this.dragEntity(this.cesiumViewer)
    this.leftDownAction(this.cesiumViewer)
    this.fetchUserInfo()

    this.warningService = new WarningService()
    this.warningService.start()
    this.warningService.onWarning((event) => {
      if (event.type === 'rainfall_alert') {
        const d = event.data
        if (this.shouldShowWarningMessage(`rain:${d.station}`, d.level)) {
          this.$message.warning({
            message: `降雨预警: ${d.station} ${d.rain}mm/h 超阈值`,
            duration: 4500,
            showClose: true,
          })
        }
        if (window.viewer) {
          new DynamicRange(window.viewer, d.lng, d.lat, 0, 150, d.level === 'red' ? '#ff0000' : '#ff8800')
          if (d.doFly) {
            window.viewer.camera.flyTo({
              destination: Cesium.Cartesian3.fromDegrees(d.lng, d.lat, 8000),
              duration: 2
            })
          }
        }
      } else if (event.type === 'water_quality_alert') {
        const d = event.data
        if (this.shouldShowWarningMessage(`water:${d.point}`, d.level)) {
          this.$message.error({
            message: `水质预警: ${d.point} NTU=${d.ntu} 超标`,
            duration: 4500,
            showClose: true,
          })
        }
        if (window.viewer && d.lng) {
          new DynamicRange(window.viewer, d.lng, d.lat, 0, 100, '#ff4444')
        }
      }
    })

    if (this.panels.currentKey === 'emergency') {
      this.$nextTick(() => this.renderEmergencyGisLayer({ fly: false }))
    }

    // 点击页面其他区域关闭下拉菜单
    document.addEventListener('click', this.closeDropdowns)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdowns)
    if (this.warningService) this.warningService.stop()
    this.stopFloodInundationAnimation()
    this.stopEmergencyFloodAnimation()
    this.hideEmergencyGisLegend()
  },
  methods: {
    shouldShowWarningMessage(key, level) {
      const now = Date.now()
      const last = this.warningMessageCache[key]
      const levelRank = { blue: 0, yellow: 1, orange: 2, red: 3 }
      if (!last || (levelRank[level] || 0) > (levelRank[last.level] || 0) || now - last.time > 180000) {
        this.warningMessageCache[key] = { time: now, level }
        return true
      }
      return false
    },

    // 关闭所有下拉菜单
    closeDropdowns(event) {
      if (!event.target.closest('.ai-assistant-container')) {
        this.aiAssistantOpen = false
      }
    },

    // 切换侧边AI助手下拉菜单
    toggleAIAssistantDropdown(event) {
      event.stopPropagation()
      this.aiAssistantOpen = !this.aiAssistantOpen
    },

    // 打开AI助手
    openAssistant(type) {
      this.aiAssistantOpen = false
      this.showKnowledgeQA(type)
    },

    // 显示AI知识问答
    showKnowledgeQA(type) {
      console.log('显示AI知识问答界面:',
          type === 'engineering' ? '工程设计知识' :
              type === 'safety' ? '施工安全管理' :
                  '运行调度AI问答'
      )
      this.currentAssistant = type
      panelStore.open(type === 'engineering' ? 'knowledgeQA' : type === 'safety' ? 'safetyQA' : 'schedulingQA')
    },

    // 关闭AI知识问答
    closeKnowledgeQA() {
      panelStore.close()
    },

    // 显示供水规模表格
    showWaterSupplyScale() {
      panelStore.open('waterSupply', { title: '供水规模统计表' })
    },

    // 显示综合监控
    showComprehensiveMonitoring() {
      panelStore.open('monitoring')
    },

    // 显示运行调度
    openStorylineGuide() {
      panelStore.open('storyline')
    },

    openStoryModule(key) {
      if (key === 'terminal') {
        window.dispatchEvent(new CustomEvent('terminal-status-open'))
        panelStore.close()
        return
      }
      const map = {
        monitoring: 'monitoring',
        floodSim: 'floodSim',
        custom: 'custom',
        supplyDemand: 'supplyDemand',
        emergency: 'emergency',
        scheduling: 'scheduling',
        knowledgeQA: 'knowledgeQA',
        reservoirInfo: 'reservoirInfo'
      }
      const target = map[key] || key
      const propsMap = {
        supplyDemand: { workflow: { area: '韩城供水区', period: '未来24小时' } },
        emergency: { recommendedPlan: '龙门镇禹门口沿河片区防汛应急联动方案', sourceWarning: '由洪水预演结果自动联动' },
        scheduling: { source: 'supplyDemand', recommendedTask: '演示导览推荐查看供需保障与运行调度任务' }
      }
      panelStore.open(target, propsMap[target] || {})
      if (target === 'floodSim' && window.viewer) {
        // 龙门镇真实坐标 110.5562°E, 35.6153°N，俯角-55°
        const _lng = 110.5562, _lat = 35.6153, _alt = 9000, _pitch = -0.9599, _heading = 0.5
        const _offset = _alt / Math.tan(Math.abs(_pitch))
        const _camLat = _lat - (_offset * Math.cos(_heading)) / 111320
        const _camLng = _lng - (_offset * Math.sin(_heading)) / (111320 * Math.cos(_lat * Math.PI / 180))
        window.viewer.camera.flyTo({
          destination: Cesium.Cartesian3.fromDegrees(_camLng, _camLat, _alt),
          orientation: { heading: _heading, pitch: _pitch, roll: 0 }
        })
      }
    },

    openEmergencyPlan(planName = '龙门镇禹门口沿河片区防汛应急联动方案') {
      panelStore.open('emergency', {
        recommendedPlan: planName,
        sourceWarning: '由洪水演进预演结果自动联动',
        flyToEmergency: true,
      })
      this.activatePlan(planName, { fly: true })
    },

    openDispatchFromSupply() {
      panelStore.open('scheduling', {
        source: 'supplyDemand',
        recommendedTask: '供需缺口调度建议'
      })
      if (window.viewer) {
        // 龙门镇真实坐标 110.5562°E, 35.6153°N，俯角-50°
        const _lng = 110.5562, _lat = 35.6153, _alt = 12000, _pitch = -0.8727, _heading = 0.5
        const _offset = _alt / Math.tan(Math.abs(_pitch))
        const _camLat = _lat - (_offset * Math.cos(_heading)) / 111320
        const _camLng = _lng - (_offset * Math.sin(_heading)) / (111320 * Math.cos(_lat * Math.PI / 180))
        window.viewer.camera.flyTo({
          destination: Cesium.Cartesian3.fromDegrees(_camLng, _camLat, _alt),
          orientation: { heading: _heading, pitch: _pitch, roll: 0 }
        })
      }
    },

    showWaterDistributionLines() {
      panelStore.open('scheduling')
    },
    gohome() {
      console.log("返回首页")
      window.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(109.461393, 35.828187, 599097.0271643074),
        orientation: {
          heading: 6.2750128595724615,
          pitch: -1.570681686183447,
          roll: 0
        }
      })
    },
    // 按钮点击处理方法
    handleButtonClick(buttonLabel) {
      console.log(`点击了按钮: ${buttonLabel}`)
      switch (buttonLabel) {
        case '运维管理':
          this.handleMaintenance()
          break
        case '应急管理':
          this.handleEmergency()
          break
        case '任务网络':
            this.handleTaskExecution()
            break
          case '工程管理':
          this.handleProjectManagement()
          break
        case '智能建造':
          this.handleSmartConstruction()
          break
        case '通知公告':
          this.handleOperationDispatch()
          break
        default:
          console.log('未知按钮')
      }
    },

    // 各个按钮的具体处理方法
    handleMaintenance() {
      panelStore.open('maintenance')
    },

    handleEmergency() {
      panelStore.open('emergency', { flyToEmergency: true })
      this.$nextTick(() => {
        this.renderEmergencyGisLayer({ fly: true })
        setTimeout(() => {
          this.flyToEmergencyGis(getActiveScenario().camera)
        }, 300)
      })
    },

    handleTaskExecution() {
      panelStore.open('taskExecution', { source: 'global' })
    },

    openEmergencyTaskExecution(context) {
      panelStore.open('taskExecution', { ...context, businessContext: context, source: 'emergencyPlan', returnPanel: 'emergency' })
    },

    returnFromTaskExecution(payload) {
      if (payload && payload.panel) panelStore.open(payload.panel, payload.props || {})
      else panelStore.close()
    },

    handleProjectManagement() {
      panelStore.open('project')
    },

    handleSmartConstruction() {
      panelStore.open('construction')
    },

    handleOperationDispatch() {
      panelStore.open('notice')
    },

    // 原有方法保持不变
    fetchUserInfo() {
      setTimeout(() => {
        this.userData = {
          name: '张工',
          role: '高级工程师'
        }
      }, 1000)
    },

    flyToLocationByName(name) {
      if (this.$refs.LocationSelector) {
        this.$refs.LocationSelector.flyToByName(name)
      }
    },

    flyToLocationById(id) {
      if (this.$refs.LocationSelector) {
        this.$refs.LocationSelector.flyToById(id)
      }
    },

    init() {
    },

    back(e) {
      console.log(e)
    },
    endSubmergence() {
      this.adjustVisible = false
    },
    resetTransientScenePanels() {
      if (this.adjustVisible && this.$refs.child && this.$refs.child.clear) {
        this.$refs.child.clear(false)
      }
      this.adjustVisible = false
      this.mulSchemesVisible = false
      // 清理3D洪水淹没动画
      this.stopFloodInundationAnimation()
    },

    nextChange() {
      this.defend = []
      panelStore.setLeftBoard(true)
      panelStore.setRightBoard(true)
      panelStore.close()
      this.adjustVisible = false
      this.mulSchemesVisible = false
    },

    addModel(val) {
      this.varChangeFlag = val
    },

    doDispatch() {
      panelStore.setLeftBoard(false)
      panelStore.setRightBoard(false)
      panelStore.open('floodSim')
      // 龙门镇真实坐标 110.5562°E, 35.6153°N，俯角-50°低空近距离
      const _dLng = 110.5562, _dLat = 35.6153, _dAlt = 1500, _dPitch = -0.8727, _dHeading = 0.5
      const _dOffset = _dAlt / Math.tan(Math.abs(_dPitch))
      const _dCamLat = _dLat - (_dOffset * Math.cos(_dHeading)) / 111320
      const _dCamLng = _dLng - (_dOffset * Math.sin(_dHeading)) / (111320 * Math.cos(_dLat * Math.PI / 180))
      window.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(_dCamLng, _dCamLat, _dAlt),
        orientation: { heading: _dHeading, pitch: _dPitch, roll: 0 }
      })
    },

    // 关闭所有弹窗的方法
    infoClose() {
      panelStore.close()
    },

    goUnbalance() {
      window.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(109.745565, 34.481791, 176726.59268938686),
        orientation: {
          heading: 6.275012859580668,
          pitch: -1.5706908082349749,
          roll: 0
        }
      })
    },

    adjust(item, defend) {
      if (this.adjustVisible && this.$refs.child && this.$refs.child.clear) {
        this.$refs.child.clear(false)
      }
      this.adjustVisible = true
      let val = {}
      if (defend != null) {
        val = {
          item: item,
          viewer: window.viewer,
          defend: defend
        }
      } else {
        val = {
          item: item,
          viewer: window.viewer,
          defend: this.defend
        }
      }

      this.$refs.child.start(val);
      if (this.riverDataSource) window.viewer.dataSources.remove(this.riverDataSource)
      this.lineEntity.forEach(item => {
        window.viewer.entities.remove(item);
      })
    },

    autoStartFloodPreview(props) {
      if (!props || !props.autoRunSchemeNum || this._lastAutoRunFloodToken === `${props.autoRunSchemeNum}-${props.scenario && props.scenario.scenario_id}`) return
      this._lastAutoRunFloodToken = `${props.autoRunSchemeNum}-${props.scenario && props.scenario.scenario_id}`
      const num = props.autoRunSchemeNum
      const schemeMap = {
        1: { num: 1, name: '下泄方案1', height_max: 462 },
        2: { num: 2, name: '下泄方案2', height_max: 460 },
        3: { num: 3, name: '下泄方案3', height_max: 458 },
      }
      const item = {
        ...(schemeMap[num] || schemeMap[2]),
        floodScenario: props.scenario || null,
        workflow: props.workflow || null,
      }
      const defend = [
        { num: 1, name: '居民区', select: true },
        { num: 2, name: '农田', select: true },
      ]
      setTimeout(() => {
        if (this.panels.currentKey === 'floodSim') {
          this.adjust(item, defend)
          // 启动3D洪水淹没动画
          const schemeData = this._getFloodSchemeData(num)
          if (schemeData) {
            setTimeout(() => this.startFloodInundationAnimation(schemeData), 600)
          }
        }
      }, 250)
    },

    flyRing() {
      window.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(110.129338, 35.993198, 3233.2084724903602),
        orientation: {
          heading: 0.16670748580508565,
          pitch: -1.3207454552714442,
          roll: 6.283032341033794
        }
      })

      let item = {
        'name': '水文站1',
        'type': 'commercial',
        "categories": 'protection',
        'color': '#00BFFF',
        'location': [110.129338, 35.993198, 450]
      }

      let Range = new DynamicRange({
        viewer: window.viewer,
      })

      let dynamicRange = Range.dynamicRange({
        item: item,
        minR: 0,
        maxR: 600,
        deviationR: 5,
      });
      this.rangeList.push(dynamicRange)
    },

    changeScheme(num, reservoirName) {
      this.mulSchemesVisible = true
      this.$nextTick(() => {
        this.$refs.mulSchemes.init(num, reservoirName)
      })
    },

    openLeftCard(title) {
      if (title == "陕西供水范围") {
        panelStore.open('detaile')
      }
    },

    toggleChat() {
      this.showChat = !this.showChat
    },

    customization() {
      panelStore.toggle('custom')
    },

    conservation(val) {
      if (this.defend.indexOf(val) == -1) {
        this.defend.push(val)
      } else {
        this.defend.splice(val, 1)
      }
    },

    changeLayer(val) {
      this.pipeObj.forEach(p => {
        window.viewer.scene.primitives.remove(p);
      });
      this.pipeObj = [];
      if (val == '1') {
        buildingPipe.forEach(item => {
          this.buildPipe(item.location, window.viewer)
        })
      } else if (val == '0') {
        FetchPipe.forEach(item => {
          this.buildPipe(item.location, window.viewer)
        })
      } else {
        this.clearPipe()
      }
    },

    clearPipe() {
      this.pipeObj.forEach(p => {
        window.viewer.scene.primitives.remove(p);
      });
      this.pipeObj = [];
    },

    initLevel(val) {
    },

    openCalc() {
      panelStore.open('calcTable')
      this.emergency = true

      let item = {
        'location': [109.559994, 34.647402, 450]
      }

      let Range = new DynamicRange({
        viewer: window.viewer,
      })

      let dynamicRange = Range.dynamicRange({
        item: item,
        minR: 10000,
        maxR: 30000,
        deviationR: 500,
      });
      this.rangeList.push(dynamicRange)
    },

    openSupplyDemand() {
      panelStore.open('supplyDemand')
      this._flyTo(110.319, 35.537, 12000)
    },

    activatePlan(planName, options = {}) {
      if (!this.getCesiumViewer()) return
      this.renderEmergencyGisLayer({ fly: !!options.fly })
      if (options.fly) {
        setTimeout(() => this.flyToEmergencyGis(getActiveScenario().camera), 300)
      }
      const info = getActiveScenarioInfo()
      this.$message.success(`预案已激活: ${planName || info.name + '防汛应急联动方案'}`)
    },

    flyToEmergencyGis(camera) {
      const viewer = this.getCesiumViewer()
      if (!viewer || !Cesium) return
      // 先渲染应急 GIS 图层，再执行飞行
      this.renderEmergencyGisLayer({ fly: false })
      const target = camera || getActiveScenario().camera
      viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(target.lng, target.lat, target.alt),
        orientation: {
          heading: target.heading,
          pitch: target.pitch,
          roll: 0,
        },
        duration: 2,
      })
      const info = getActiveScenarioInfo()
      this.$message.success(`已跳转至${info.name} GIS 界面`)
    },

    onEmergencyScenarioChanged() {
      // 场景切换后重新渲染 GIS 图层并飞行到新位置
      this.$nextTick(() => {
        this.renderEmergencyGisLayer({ fly: true })
        setTimeout(() => {
          this.flyToEmergencyGis(getActiveScenario().camera)
        }, 300)
      })
    },

    clearEmergencyGisLayer() {
      this.hideEmergencyGisLegend()
      this.stopEmergencyFloodAnimation()
      const viewer = this.getCesiumViewer()
      if (!viewer || !this.emergencyGisEntities.length) return
      this.emergencyGisEntities.forEach(entity => {
        if (entity) viewer.entities.remove(entity)
      })
      this.emergencyGisEntities = []
    },

    renderEmergencyGisLayer(options = {}) {
      const viewer = this.getCesiumViewer()
      if (!viewer || !Cesium) return
      this.clearEmergencyGisLayer()
      const data = getActiveScenario()

      // ── 1. 下泄影响走廊（折线 + 关键点图钉） ──
      if (data.releaseCorridor) {
        const corridor = data.releaseCorridor
        const positions = Cesium.Cartesian3.fromDegreesArray(corridor.positions.flat())
        const corridorColor = Cesium.Color.fromCssColorString(corridor.color)
        // 折线
        this.emergencyGisEntities.push(viewer.entities.add({
          id: `emergency-${corridor.id}`,
          name: corridor.name,
          emergencyType: 'release-corridor',
          polyline: {
            positions,
            width: 9,
            clampToGround: true,
            material: new Cesium.PolylineGlowMaterialProperty({
              glowPower: 0.32,
              color: corridorColor.withAlpha(0.78),
            }),
          },
          position: Cesium.Cartesian3.fromDegrees(corridor.positions[2][0], corridor.positions[2][1], 220),
          label: {
            text: corridor.name,
            font: '16px sans-serif',
            fillColor: Cesium.Color.WHITE,
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 4,
            style: Cesium.LabelStyle.FILL_AND_OUTLINE,
            pixelOffset: new Cesium.Cartesian2(0, -30),
            distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 120000),
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
          },
          description: `<strong>${corridor.name}</strong><br/>${corridor.warning}<br/>全长：${corridor.lengthKm} km`,
        }))
        // 走廊关键点图钉
        const pointLabels = corridor.pointLabels || []
        const corridorPinIcons = { origin: '坝', station: '站', section: '断', control: '控', endpoint: '滩' }
        corridor.positions.forEach((pos, idx) => {
          const label = pointLabels[idx] || { name: `走廊点${idx + 1}`, type: 'station' }
          const pinText = corridorPinIcons[label.type] || '点'
          this.emergencyGisEntities.push(viewer.entities.add({
            id: `emergency-${corridor.id}-pt-${idx}`,
            name: label.name,
            emergencyType: 'corridor-point',
            position: Cesium.Cartesian3.fromDegrees(pos[0], pos[1], 180),
          billboard: this.makeEmergencyPin(pinText, corridor.color),
          label: {
            text: label.name,
            font: '12px sans-serif',
            fillColor: corridorColor,
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 3,
            style: Cesium.LabelStyle.FILL_AND_OUTLINE,
            pixelOffset: new Cesium.Cartesian2(0, -38),
            distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 80000),
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
          },
            description: `<strong>${label.name}</strong><br/>走廊节点 ${idx + 1}/${corridor.positions.length}<br/>坐标：${pos[0].toFixed(4)}°E, ${pos[1].toFixed(4)}°N`,
          }))
        })
      }

      // ── 2. 管控分区（多边形） ──
      data.zones.forEach(zone => {
        const hierarchy = Cesium.Cartesian3.fromDegreesArray(zone.positions.flat())
        this.emergencyGisEntities.push(viewer.entities.add({
          id: `emergency-${zone.id}`,
          name: zone.name,
          emergencyType: 'zone',
          polygon: {
            hierarchy,
            material: Cesium.Color.fromCssColorString(zone.color).withAlpha(0.18),
            outline: true,
            outlineColor: Cesium.Color.fromCssColorString(zone.color).withAlpha(0.9),
          },
          position: Cesium.Cartesian3.fromDegrees(zone.positions[0][0], zone.positions[0][1], 120),
          label: {
            text: zone.name,
            font: '14px sans-serif',
            fillColor: Cesium.Color.WHITE,
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 3,
            style: Cesium.LabelStyle.FILL_AND_OUTLINE,
            pixelOffset: new Cesium.Cartesian2(0, -18),
            distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 90000),
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
          },
          description: `<strong>${zone.name}</strong><br/>规则：${zone.rule}<br/>动作：${zone.action}`,
        }))
      })

      // ── 3. 转移路线（折线 + 起点/终点图钉） ──
      data.routes.forEach(route => {
        const positions = Cesium.Cartesian3.fromDegreesArray(route.positions.flat())
        const color = Cesium.Color.fromCssColorString(route.color)
        // 路线折线
        this.emergencyGisEntities.push(viewer.entities.add({
          id: `emergency-${route.id}`,
          name: route.name,
          emergencyType: 'route',
          polyline: {
            positions,
            width: 5,
            clampToGround: true,
            material: new Cesium.PolylineGlowMaterialProperty({
              glowPower: 0.22,
              color: color.withAlpha(0.92),
            }),
          },
          position: Cesium.Cartesian3.fromDegrees(route.positions[Math.floor(route.positions.length / 2)][0], route.positions[Math.floor(route.positions.length / 2)][1], 180),
          label: {
            text: `${route.name}\n${route.walkMinutes}分钟 / ${route.distanceKm}km`,
            font: '13px sans-serif',
            fillColor: color,
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 3,
            style: Cesium.LabelStyle.FILL_AND_OUTLINE,
            pixelOffset: new Cesium.Cartesian2(0, -24),
            distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 70000),
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
          },
          description: `<strong>${route.name}</strong><br/>起点：${route.start}<br/>终点：${route.end}<br/>容量：${route.capacity}人<br/>守控：${route.guard}`,
        }))
        // 路线起点图钉
        const startPos = route.positions[0]
        this.emergencyGisEntities.push(viewer.entities.add({
          id: `emergency-${route.id}-start`,
          name: `${route.name}-起点`,
          emergencyType: 'route-start',
          position: Cesium.Cartesian3.fromDegrees(startPos[0], startPos[1], 180),
          billboard: this.makeEmergencyPin('起', route.color),
          label: {
            text: route.start,
            font: '12px sans-serif',
            fillColor: color,
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 3,
            style: Cesium.LabelStyle.FILL_AND_OUTLINE,
            pixelOffset: new Cesium.Cartesian2(0, -38),
            distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 60000),
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
          },
          description: `<strong>${route.name} - 起点</strong><br/>${route.start}<br/>容量：${route.capacity}人`,
        }))
        // 路线终点图钉
        const endPos = route.positions[route.positions.length - 1]
        this.emergencyGisEntities.push(viewer.entities.add({
          id: `emergency-${route.id}-end`,
          name: `${route.name}-终点`,
          emergencyType: 'route-end',
          position: Cesium.Cartesian3.fromDegrees(endPos[0], endPos[1], 180),
          billboard: this.makeEmergencyPin('终', route.color),
          label: {
            text: route.end,
            font: '12px sans-serif',
            fillColor: color,
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 3,
            style: Cesium.LabelStyle.FILL_AND_OUTLINE,
            pixelOffset: new Cesium.Cartesian2(0, -38),
            distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 60000),
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
          },
          description: `<strong>${route.name} - 终点</strong><br/>${route.end}<br/>步行：${route.walkMinutes}分钟`,
        }))
      })

      // ── 4. 响应断面（图钉） ──
      ;(data.responseSections || []).forEach(section => {
        this.emergencyGisEntities.push(viewer.entities.add({
          id: `emergency-${section.id}`,
          name: section.name,
          emergencyType: 'response-section',
          position: Cesium.Cartesian3.fromDegrees(section.lng, section.lat, 220),
          billboard: this.makeEmergencyPin('断', '#7c3cff'),
          label: {
            text: `${section.name}\n${section.level}`,
            font: '13px sans-serif',
            fillColor: Cesium.Color.WHITE,
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 3,
            style: Cesium.LabelStyle.FILL_AND_OUTLINE,
            pixelOffset: new Cesium.Cartesian2(0, -42),
            distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 90000),
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
          },
          description: `<strong>${section.name}</strong><br/>级别：${section.level}<br/>监测站：${section.station}<br/>警戒水位：${section.warningLevel}<br/>设计水位：${section.designLevel}<br/>响应时限：${section.responseTime}<br/>动作：${section.action}`,
        }))
      })

      // ── 5. 风险点（图钉，按红/橙/黄区着色） ──
      data.riskPoints.forEach(point => {
        const color = this.emergencyZoneColor(point.zone)
        const zoneColorCss = point.zone === 'red' ? '#ff4d4f' : point.zone === 'orange' ? '#ff8a3d' : '#f8ff59'
        this.emergencyGisEntities.push(viewer.entities.add({
          id: `emergency-${point.id}`,
          name: point.name,
          emergencyType: 'risk',
          position: Cesium.Cartesian3.fromDegrees(point.lng, point.lat, 180),
          billboard: this.makeEmergencyPin('险', zoneColorCss),
          label: {
            text: `${point.name}\n${point.people}人 / 超阈${point.exceedance}m`,
            font: '13px sans-serif',
            fillColor: Cesium.Color.WHITE,
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 3,
            style: Cesium.LabelStyle.FILL_AND_OUTLINE,
            pixelOffset: new Cesium.Cartesian2(0, -42),
            distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 80000),
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
          },
          description: `<strong>${point.name}</strong><br/>类型：${point.type}<br/>分区：${point.zone}<br/>人数：${point.people}<br/>超阈：${point.exceedance} m<br/>优先级：${point.priority}<br/>联系人：${point.contact}<br/>动作：${point.action}`,
        }))
      })

      // ── 6. 避险点（图钉 + 多边形区域） ──
      data.shelters.forEach(point => {
        // 如果有 polygon 字段，先绘制多边形区域
        if (point.polygon && point.polygon.length >= 3) {
          this.emergencyGisEntities.push(viewer.entities.add({
            id: `emergency-${point.id}-poly`,
            name: `${point.name}（区域）`,
            emergencyType: 'shelter-area',
            polygon: {
              hierarchy: Cesium.Cartesian3.fromDegreesArray(point.polygon.flat()),
              material: Cesium.Color.fromCssColorString('#25d9ff').withAlpha(0.15),
              outline: true,
              outlineColor: Cesium.Color.fromCssColorString('#25d9ff').withAlpha(0.8),
              height: 2,
            },
            description: `<strong>${point.name} - 区域</strong><br/>级别：${point.level}<br/>容量：${point.capacity}人`,
          }))
        }
        this.emergencyGisEntities.push(viewer.entities.add({
          id: `emergency-${point.id}`,
          name: point.name,
          emergencyType: 'shelter',
          position: Cesium.Cartesian3.fromDegrees(point.lng, point.lat, 180),
          billboard: this.makeEmergencyPin('避', '#25d9ff'),
          label: {
            text: `${point.name}\n${point.level} / ${point.capacity}人`,
            font: '13px sans-serif',
            fillColor: Cesium.Color.CYAN,
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 3,
            style: Cesium.LabelStyle.FILL_AND_OUTLINE,
            pixelOffset: new Cesium.Cartesian2(0, -42),
            distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 80000),
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
          },
          description: `<strong>${point.name}</strong><br/>级别：${point.level}<br/>容量：${point.capacity}人<br/>负责人：${point.manager}<br/>物资：${point.supplies}<br/>登记：${point.register}`,
        }))
      })

      // ── 7. 物资点（图钉 + 多边形区域） ──
      data.materialPoints.forEach(point => {
        // 如果有 polygon 字段，先绘制多边形区域
        if (point.polygon && point.polygon.length >= 3) {
          this.emergencyGisEntities.push(viewer.entities.add({
            id: `emergency-${point.id}-poly`,
            name: `${point.name}（区域）`,
            emergencyType: 'material-area',
            polygon: {
              hierarchy: Cesium.Cartesian3.fromDegreesArray(point.polygon.flat()),
              material: Cesium.Color.fromCssColorString('#facc15').withAlpha(0.12),
              outline: true,
              outlineColor: Cesium.Color.fromCssColorString('#facc15').withAlpha(0.7),
              height: 2,
            },
            description: `<strong>${point.name} - 区域</strong><br/>物资：${point.material}`,
          }))
        }
        this.emergencyGisEntities.push(viewer.entities.add({
          id: `emergency-${point.id}`,
          name: point.name,
          emergencyType: 'material',
          position: Cesium.Cartesian3.fromDegrees(point.lng, point.lat, 180),
          billboard: this.makeEmergencyPin('物', '#facc15'),
          label: {
            text: `${point.name}\n${point.material}`,
            font: '12px sans-serif',
            fillColor: Cesium.Color.YELLOW,
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 3,
            style: Cesium.LabelStyle.FILL_AND_OUTLINE,
            pixelOffset: new Cesium.Cartesian2(0, -38),
            distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 70000),
            disableDepthTestDistance: Number.POSITIVE_INFINITY,
          },
          description: `<strong>${point.name}</strong><br/>物资：${point.material}<br/>管理员：${point.manager}<br/>去向：${point.target}`,
        }))
      })

      // ── 8. 显示 GIS 图例 ──
      this.showEmergencyGisLegend()

      // ── 9. 启动洪水演进动画 ──
      if (data.floodAnimation && data.floodAnimation.enabled) {
        this.startEmergencyFloodAnimation(data.floodAnimation)
      }

      if (options.fly) {
        viewer.camera.flyTo({
          destination: Cesium.Cartesian3.fromDegrees(data.camera.lng, data.camera.lat, data.camera.alt),
          orientation: {
            heading: data.camera.heading,
            pitch: data.camera.pitch,
            roll: 0,
          },
          duration: 2,
        })
      }
    },

    showEmergencyGisLegend() {
      this.hideEmergencyGisLegend()
      const legend = document.createElement('div')
      legend.id = 'emergency-gis-legend'
      legend.style.cssText = [
        'position:fixed',
        'left:18px',
        'bottom:96px',
        'z-index:9997',
        'background:rgba(3,18,30,0.88)',
        'border:1px solid rgba(99,179,237,0.28)',
        'border-radius:10px',
        'padding:12px 16px',
        'color:#76d9ff',
        'font-size:12px',
        'font-family:sans-serif',
        'backdrop-filter:blur(8px)',
        'box-shadow:0 8px 28px rgba(0,0,0,0.38)',
        'max-width:220px',
        'pointer-events:auto',
      ].join(';')
      const items = [
        { icon: '坝', color: '#38f8ff', label: '下泄走廊关键点' },
        { icon: '断', color: '#7c3cff', label: '响应断面（3个）' },
        { icon: '险', color: '#ff4d4f', label: '风险点（5个）' },
        { icon: '避', color: '#25d9ff', label: '避险/安置点（5个）' },
        { icon: '物', color: '#facc15', label: '物资点（4个）' },
        { icon: '起', color: '#38f8ff', label: '转移路线起点' },
        { icon: '终', color: '#38f8ff', label: '转移路线终点' },
        { icon: '洪', color: '#ff6b35', label: '洪水演进动画' },
      ]
      const title = document.createElement('div')
      title.textContent = '应急 GIS 图层图例'
      title.style.cssText = 'font-size:14px;font-weight:bold;color:#76d9ff;margin-bottom:8px;border-bottom:1px solid rgba(99,179,237,0.2);padding-bottom:6px'
      legend.appendChild(title)
      items.forEach(item => {
        const row = document.createElement('div')
        row.style.cssText = 'display:flex;align-items:center;gap:8px;margin:4px 0'
        const badge = document.createElement('span')
        badge.textContent = item.icon
        badge.style.cssText = `display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:50%;background:${item.color};color:#fff;font-size:11px;font-weight:bold;flex-shrink:0`
        const text = document.createElement('span')
        text.textContent = item.label
        text.style.cssText = 'color:#dffcff;line-height:1.4'
        row.appendChild(badge)
        row.appendChild(text)
        legend.appendChild(row)
      })
      // 分区说明
      const zoneTitle = document.createElement('div')
      zoneTitle.textContent = '管控分区'
      zoneTitle.style.cssText = 'font-size:13px;font-weight:bold;color:#76d9ff;margin:8px 0 4px;border-top:1px solid rgba(99,179,237,0.15);padding-top:6px'
      legend.appendChild(zoneTitle)
      const zones = [
        { color: '#ff4d4f', label: '红区：禁留带' },
        { color: '#ff8a3d', label: '橙区：7分钟撤离' },
        { color: '#f8ff59', label: '黄区：穿越区' },
        { color: '#25d9ff', label: '蓝区：安置区' },
      ]
      zones.forEach(z => {
        const row = document.createElement('div')
        row.style.cssText = 'display:flex;align-items:center;gap:8px;margin:3px 0'
        const swatch = document.createElement('span')
        swatch.style.cssText = `display:inline-block;width:16px;height:16px;border-radius:3px;background:${z.color};opacity:0.7;border:1px solid ${z.color};flex-shrink:0`
        const text = document.createElement('span')
        text.textContent = z.label
        text.style.cssText = 'color:#dffcff;line-height:1.4'
        row.appendChild(swatch)
        row.appendChild(text)
        legend.appendChild(row)
      })
      document.body.appendChild(legend)
    },

    hideEmergencyGisLegend() {
      const existing = document.getElementById('emergency-gis-legend')
      if (existing) existing.remove()
    },

    emergencyZoneColor(zone) {
      const colors = {
        red: '#ff4d4f',
        orange: '#ff8a3d',
        yellow: '#f8ff59',
        blue: '#25d9ff',
      }
      return Cesium.Color.fromCssColorString(colors[zone] || '#25d9ff')
    },

    makeEmergencyPin(text, color) {
      const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64"><path d="M32 4c12.7 0 23 10.3 23 23 0 17.3-23 33-23 33S9 44.3 9 27C9 14.3 19.3 4 32 4z" fill="${color}" stroke="white" stroke-width="3"/><circle cx="32" cy="27" r="15" fill="rgba(0,0,0,.35)"/><text x="32" y="33" text-anchor="middle" font-size="20" font-family="Arial, sans-serif" font-weight="700" fill="white">${text}</text></svg>`
      return {
        image: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`,
        width: 34,
        height: 34,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        disableDepthTestDistance: Number.POSITIVE_INFINITY,
      }
    },

    getCesiumViewer() {
      return this.cesiumViewer || window.viewer
    },

    /**
     * Single source of truth for gesture-interactive reservoir targets. The
     * entity remains the existing Cesium Entity; this registry only adds the
     * business identity and interaction metadata around it.
     */
    getReservoirInteractiveRegistry() {
      return this.reservoirRegistry
    },

    getReservoirScreenTargets() {
      const viewer = this.getCesiumViewer()
      if (!viewer || !viewer.scene || !viewer.canvas) return []
      const rect = viewer.canvas.getBoundingClientRect()
      const now = Cesium.JulianDate.now()
      let occluder = null
      try {
        if (viewer.scene.globe && viewer.scene.globe.ellipsoid && Cesium.EllipsoidalOccluder) {
          occluder = new Cesium.EllipsoidalOccluder(viewer.scene.globe.ellipsoid, viewer.camera.position)
        }
      } catch (_) {}
      return Object.values(this.reservoirRegistry).map((target) => {
        const entity = target.entity
        const { entity: _entity, ...metadata } = target
        const position = entity && entity.position && typeof entity.position.getValue === 'function'
          ? entity.position.getValue(now)
          : null
        if (!position) return { ...metadata, visible: false }
        if (occluder && !occluder.isPointVisible(position)) return { ...metadata, visible: false }
        let canvasPosition = null
        try {
          if (viewer.scene.cartesianToCanvasCoordinates) {
            canvasPosition = viewer.scene.cartesianToCanvasCoordinates(position)
          }
          if (!canvasPosition && Cesium.SceneTransforms && Cesium.SceneTransforms.wgs84ToWindowCoordinates) {
            canvasPosition = Cesium.SceneTransforms.wgs84ToWindowCoordinates(viewer.scene, position)
          }
        } catch (_) {
          canvasPosition = null
        }
        if (!canvasPosition || !Number.isFinite(canvasPosition.x) || !Number.isFinite(canvasPosition.y)) {
          return { ...metadata, visible: false }
        }
        const screenPosition = {
          x: rect.left + canvasPosition.x,
          y: rect.top + canvasPosition.y,
        }
        const visible = screenPosition.x >= rect.left - 40
          && screenPosition.x <= rect.right + 40
          && screenPosition.y >= rect.top - 40
          && screenPosition.y <= rect.bottom + 40
        return { ...metadata, visible, screenPosition }
      }).filter(target => target.visible)
    },

    setReservoirInteractionState(target, { hovered = false, locked = false, selectedTarget = null } = {}) {
      const key = target && (target.key || target.businessId)
      const selectedKey = selectedTarget && (selectedTarget.key || selectedTarget.businessId)
      Object.values(this.reservoirRegistry).forEach((entry) => {
        const isSelected = Boolean(selectedKey && entry.key === selectedKey)
        const isHovered = Boolean(key && entry.key === key && hovered)
        const active = isSelected || isHovered || Boolean(key && entry.key === key && locked)
        const entity = entry.entity
        if (!entity) return
        try {
          if (entity.point) entity.point.pixelSize = active ? (isSelected ? 22 : 19) : 14
          if (entity.billboard) entity.billboard.scale = active ? (isSelected ? 1.22 : 1.1) : 1
          if (entity.label) entity.label.fillColor = active
            ? Cesium.Color.fromCssColorString(isSelected ? '#65f6cf' : '#38f8ff')
            : Cesium.Color.fromCssColorString(entry.color || '#00BFFF')
        } catch (_) {}
      })
    },

    _assistantError(code, message) {
      const error = new Error(message)
      error.code = code
      return error
    },

    _assistantFindEntity(objectId) {
      const viewer = this.getCesiumViewer()
      if (!viewer) return null
      if (this.poinEntity && this.poinEntity[objectId]) return this.poinEntity[objectId]
      const registryTarget = Object.values(this.reservoirRegistry || {})
        .find(target => target.businessId === objectId || target.entityId === objectId)
      if (registryTarget && registryTarget.entity) return registryTarget.entity
      let entity = viewer.entities && viewer.entities.getById(objectId)
      if (entity) return entity
      const sources = viewer.dataSources
      for (let index = 0; sources && index < sources.length; index += 1) {
        const source = sources.get(index)
        entity = source && source.entities && source.entities.getById(objectId)
        if (entity) return entity
      }
      return null
    },

    _assistantTargetFromEntity(entity) {
      if (!entity) return null
      const rawType = entity.objectType || entity.categories
        || (entity.monitoItems && entity.monitoItems.data && entity.monitoItems.data.categories)
      const objectType = this._assistantNormalizeObjectType(rawType)
      if (!objectType) return null
      const businessData = entity.monitoItems && entity.monitoItems.data
      return {
        objectId: String((businessData && businessData.id) || entity.id),
        objectType,
        displayName: entity.name || (businessData && businessData.name) || String(entity.id),
        ...(entity.businessId ? { businessId: String(entity.businessId) } : {}),
      }
    },

    _assistantNormalizeObjectType(rawType) {
      const reservoirTypes = ['reservoir', 'regulating', 'regulatingReservoir']
      const regionTypes = ['region', 'district', 'industrial', 'protection']
      return reservoirTypes.includes(rawType)
        ? 'reservoir'
        : (regionTypes.includes(rawType) ? 'region' : null)
    },

    _assistantTargetFromPick(picked) {
      if (!picked) return null
      const candidate = picked.id || (picked.primitive && picked.primitive.id)
      if (candidate) {
        const entity = typeof candidate === 'string'
          ? this._assistantFindEntity(candidate)
          : candidate
        const target = this._assistantTargetFromEntity(entity)
        if (target) return target
      }

      const feature = picked.primitive || picked
      if (!feature || typeof feature.getProperty !== 'function') return null
      const objectId = feature.getProperty('objectId') || feature.getProperty('id')
      const rawType = feature.getProperty('objectType') || feature.getProperty('categories')
      const displayName = feature.getProperty('displayName') || feature.getProperty('name')
      const objectType = this._assistantNormalizeObjectType(rawType)
      if (!objectId || !objectType || !displayName) return null
      return { objectId: String(objectId), objectType, displayName: String(displayName) }
    },

    assistantPickPointerTarget(screenX, screenY) {
      const viewer = this.getCesiumViewer()
      if (!viewer || !viewer.scene || !viewer.canvas) return null
      const rect = viewer.canvas.getBoundingClientRect()
      const localX = Number(screenX) - rect.left
      const localY = Number(screenY) - rect.top
      if (!Number.isFinite(localX) || !Number.isFinite(localY)
          || localX < 0 || localY < 0 || localX > rect.width || localY > rect.height) {
        return null
      }
      const position = new Cesium.Cartesian2(localX, localY)
      const picks = typeof viewer.scene.drillPick === 'function'
        ? viewer.scene.drillPick(position, 10)
        : [viewer.scene.pick(position)]
      const candidates = []
      const seen = new Set()
      for (const picked of picks || []) {
        const target = this._assistantTargetFromPick(picked)
        if (!target) continue
        const key = `${target.objectType}:${target.objectId}`
        if (seen.has(key)) continue
        seen.add(key)
        candidates.push(target)
      }
      if (candidates.length === 0) return null
      return {
        ...candidates[0],
        ...(candidates.length > 1 ? { candidates } : {}),
      }
    },

    _assistantCameraSnapshot(viewer) {
      return {
        position: Cesium.Cartesian3.clone(viewer.camera.position),
        heading: viewer.camera.heading,
        pitch: viewer.camera.pitch,
        roll: viewer.camera.roll,
      }
    },

    async assistantSelectObject(target, locate = true) {
      const viewer = this.getCesiumViewer()
      if (!viewer) throw this._assistantError('SCENE_NOT_READY', 'Cesium viewer is not ready')
      const entity = this._assistantFindEntity(target.objectId)
      if (!entity) throw this._assistantError('TARGET_NOT_FOUND', `Target not found: ${target.objectId}`)
      const resolvedTarget = this._assistantTargetFromEntity(entity)
      if (!resolvedTarget || resolvedTarget.objectType !== target.objectType) {
        throw this._assistantError('TARGET_TYPE_UNSUPPORTED', `Unsupported or mismatched target type: ${target.objectType}`)
      }

      const previousEntity = viewer.selectedEntity || null
      const snapshot = {
        previousEntity,
        camera: this._assistantCameraSnapshot(viewer),
      }
      viewer.selectedEntity = entity
      let located = false
      if (locate) {
        try {
          const flyResult = await Promise.resolve(viewer.flyTo(entity, { duration: 0.8 }))
          if (flyResult === false) throw new Error('viewer.flyTo returned false')
          located = true
        } catch (error) {
          viewer.selectedEntity = previousEntity || undefined
          throw this._assistantError('CAMERA_LOCATE_FAILED', error.message || 'Failed to locate target')
        }
      }
      return {
        selectedTarget: { ...resolvedTarget, displayName: target.displayName || resolvedTarget.displayName },
        located,
        previousTarget: this._assistantTargetFromEntity(previousEntity),
        snapshot,
      }
    },

    async assistantRestoreSelection(snapshot) {
      const viewer = this.getCesiumViewer()
      if (!viewer || !snapshot) throw this._assistantError('RESTORE_FAILED', 'Selection snapshot is unavailable')
      viewer.selectedEntity = snapshot.previousEntity || undefined
      if (snapshot.camera) {
        viewer.camera.setView({
          destination: snapshot.camera.position,
          orientation: {
            heading: snapshot.camera.heading,
            pitch: snapshot.camera.pitch,
            roll: snapshot.camera.roll,
          },
        })
      }
    },

    async assistantOpenPanel(panelId, focus = true) {
      if (panelId !== 'flood-analysis') throw this._assistantError('PANEL_NOT_FOUND', `Unknown panel: ${panelId}`)
      const snapshot = {
        currentKey: panelStore.currentKey,
        currentProps: { ...(panelStore.currentProps || {}) },
        showLeftBoard: panelStore.showLeftBoard,
        showRightBoard: panelStore.showRightBoard,
      }
      const wasAlreadyOpen = panelStore.currentKey === 'submergence'
      if (!wasAlreadyOpen) panelStore.open('submergence', { source: 'assistant-sdk' })
      if (panelStore.currentKey !== 'submergence') throw this._assistantError('PANEL_OPEN_FAILED', 'Flood analysis panel is not registered')
      if (focus) {
        await this.$nextTick()
        const panel = this.$el && this.$el.querySelector('.panel-host')
        if (panel) {
          panel.setAttribute('tabindex', '-1')
          panel.focus()
        }
      }
      return { opened: true, wasAlreadyOpen, snapshot }
    },

    async assistantRestorePanel(snapshot) {
      if (!snapshot) throw this._assistantError('RESTORE_FAILED', 'Panel snapshot is unavailable')
      if (snapshot.currentKey) panelStore.open(snapshot.currentKey, snapshot.currentProps || {})
      else panelStore.close()
      panelStore.setLeftBoard(Boolean(snapshot.showLeftBoard))
      panelStore.setRightBoard(Boolean(snapshot.showRightBoard))
    },

    async assistantShowFloodRange(analysis) {
      const viewer = this.getCesiumViewer()
      if (!viewer) throw this._assistantError('SCENE_NOT_READY', 'Cesium viewer is not ready')
      if (!analysis || !analysis.analysisId || !analysis.range || !analysis.range.features || !analysis.range.features.length) {
        throw this._assistantError('RANGE_DATA_INVALID', 'Analysis range is empty or invalid')
      }
      if (this.assistantAnalysisLayers[analysis.analysisId]) {
        throw this._assistantError('LAYER_RENDER_FAILED', `Analysis is already visible: ${analysis.analysisId}`)
      }

      let dataSource
      try {
        dataSource = await Cesium.GeoJsonDataSource.load(analysis.range, {
          clampToGround: true,
          stroke: Cesium.Color.fromCssColorString('#37d7ff'),
          fill: Cesium.Color.fromCssColorString('#1e8fff').withAlpha(0.42),
          strokeWidth: 2,
        })
        dataSource.name = `assistant-analysis:${analysis.analysisId}`
        await viewer.dataSources.add(dataSource)
      } catch (error) {
        throw this._assistantError('LAYER_RENDER_FAILED', error.message || 'Failed to render flood range')
      }

      const entities = dataSource.entities.values || []
      if (!entities.length) {
        viewer.dataSources.remove(dataSource, true)
        throw this._assistantError('RANGE_DATA_INVALID', 'GeoJSON produced no Cesium entities')
      }
      const layerIds = entities.map((entity, index) => String(entity.id || `${analysis.analysisId}:${index}`))
      const record = { analysis, dataSource, layerIds }
      this.$set(this.assistantAnalysisLayers, analysis.analysisId, record)
      return {
        analysisId: analysis.analysisId,
        layerIds,
        renderedFeatureCount: entities.length,
        snapshot: { analysisId: analysis.analysisId, record },
      }
    },

    async assistantUndoShowRange(snapshot) {
      const viewer = this.getCesiumViewer()
      const record = snapshot && snapshot.record
      if (!viewer || !record) throw this._assistantError('RESTORE_FAILED', 'Rendered layer snapshot is unavailable')
      viewer.dataSources.remove(record.dataSource, false)
      this.$delete(this.assistantAnalysisLayers, snapshot.analysisId)
    },

    async assistantClearAnalysis(analysisId) {
      const viewer = this.getCesiumViewer()
      if (!viewer) throw this._assistantError('SCENE_NOT_READY', 'Cesium viewer is not ready')
      const record = this.assistantAnalysisLayers[analysisId]
      if (!record) throw this._assistantError('ANALYSIS_NOT_FOUND', `Analysis not found: ${analysisId}`)
      const collectionIndex = viewer.dataSources.indexOf(record.dataSource)
      const removed = viewer.dataSources.remove(record.dataSource, false)
      if (!removed) throw this._assistantError('CLEAR_FAILED', `Failed to clear analysis: ${analysisId}`)
      this.$delete(this.assistantAnalysisLayers, analysisId)
      return {
        analysisId,
        clearedLayerIds: record.layerIds.slice(),
        snapshot: { analysisId, record, collectionIndex },
      }
    },

    async assistantRestoreAnalysis(snapshot) {
      const viewer = this.getCesiumViewer()
      const record = snapshot && snapshot.record
      if (!viewer || !record) throw this._assistantError('RESTORE_FAILED', 'Analysis snapshot is unavailable')
      if (this.assistantAnalysisLayers[snapshot.analysisId]) {
        throw this._assistantError('RESTORE_FAILED', `Analysis is already visible: ${snapshot.analysisId}`)
      }
      await viewer.dataSources.add(record.dataSource)
      if (Number.isInteger(snapshot.collectionIndex) && snapshot.collectionIndex >= 0) {
        while (viewer.dataSources.indexOf(record.dataSource) > snapshot.collectionIndex) {
          viewer.dataSources.lower(record.dataSource)
        }
      }
      this.$set(this.assistantAnalysisLayers, snapshot.analysisId, record)
    },

    getAssistantContextSummary() {
      const viewer = this.getCesiumViewer()
      if (!viewer) {
        return { selectedObject: null, activePanel: panelStore.currentKey, activeLayers: [], mapView: null }
      }
      const activeLayers = []
      for (let index = 0; viewer.dataSources && index < viewer.dataSources.length; index += 1) {
        const source = viewer.dataSources.get(index)
        if (source && source.show !== false) activeLayers.push(source.name || `data-source-${index}`)
      }
      const position = viewer.camera.positionCartographic
      const rectangle = viewer.camera.computeViewRectangle(viewer.scene.globe.ellipsoid)
      const degrees = value => Number(Cesium.Math.toDegrees(value).toFixed(6))
      const mapView = position ? {
        longitude: degrees(position.longitude),
        latitude: degrees(position.latitude),
        height: Number(position.height.toFixed(1)),
        heading: Number(viewer.camera.heading.toFixed(6)),
        pitch: Number(viewer.camera.pitch.toFixed(6)),
        roll: Number(viewer.camera.roll.toFixed(6)),
        rectangle: rectangle ? {
          west: degrees(rectangle.west),
          south: degrees(rectangle.south),
          east: degrees(rectangle.east),
          north: degrees(rectangle.north),
        } : null,
      } : null
      return {
        selectedObject: this._assistantTargetFromEntity(viewer.selectedEntity),
        activePanel: panelStore.currentKey,
        activeLayers: Array.from(new Set(activeLayers)),
        mapView,
      }
    },

    _flyTo(lng, lat, alt = 8000) {
      const viewer = this.getCesiumViewer()
      if (viewer) {
        viewer.camera.flyTo({
          destination: Cesium.Cartesian3.fromDegrees(lng, lat, alt),
          duration: 1.5
        })
      }
    },

    leftDownAction(viewer) {
      let handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
      handler.setInputAction((movement) => {
        try {
          let pick = viewer.scene.pick(movement.position);
          if (!Cesium.defined(pick) || !pick.id) return;

          // 管线类别（直接挂在 entity 上的 categories 属性）
          if (pick.id.categories) {
            if (pick.id.categories == "highTrunkLine") {
              panelStore.open('hightTrunk')
            } else if (pick.id.categories == "branchTrunkLine") {
              panelStore.open('branchTrunk')
            }
            return
          }

          // 监测点、水库等实体（monitoItems.data.categories）
          let monitoData = pick.id.monitoItems && pick.id.monitoItems.data
          if (!monitoData || !monitoData.categories) return

          const cats = monitoData.categories
          if (cats == 'monitoring') {
            this.bubble(monitoData.id)
          } else if (cats == 'protection') {
            this.info = monitoData
            panelStore.open('protection', { info: monitoData })
          } else if (cats == 'industrial') {
            this.info = monitoData
            panelStore.open('industrial', { info: monitoData })
          } else if (cats == 'reservoir') {
            this.info = monitoData
            panelStore.open('reservoir', { info: monitoData })
          } else if (cats == 'regulating') {
            this.info = monitoData
            panelStore.open('regulating', { info: monitoData })
          } else if (cats == 'pump') {
            this.info = monitoData
            panelStore.open('pumping', { info: monitoData })
          } else if (cats == 'pool') {
            this.info = monitoData
            panelStore.open('pool', { info: monitoData })
          } else if (cats == 'irrigation') {
            this.info = monitoData
            if (this.emergency) {
              this.info.showEmergency = true
            }
            panelStore.open('irrigation', { info: this.info })
          }
        } catch (e) {
          // 点击空白或异常实体时静默处理，避免阻塞后续点击
        }
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
    },

    dragEntity(viwer) {
      let drag = new DragEntity({
        viewer: viwer,
      })
      monitoring.forEach(item => {
        let entity = drag.addMonitoring(item);
        this.poinEntity[item.id] = entity;
      })
      building.forEach(item => {
        let entity = drag.addMonitoring(item);
        this.poinEntity[item.id] = entity;
      })

      hyStations.forEach(item => {
        let entity = drag.addReservoir(item);
        const reservoir = listReservoirs().find(candidate => candidate.name === item.name)
        entity.objectType = 'reservoir'
        entity.businessId = reservoir ? reservoir.id : item.id
        entity.entityId = entity.id
        this.poinEntity[item.id] = entity;
        const key = `${entity.businessId}:reservoir`
        this.$set(this.reservoirRegistry, key, {
          key,
          objectType: 'reservoir',
          objectId: item.id,
          entityId: entity.id,
          businessId: entity.businessId,
          displayName: item.name,
          name: item.name,
          color: item.color || '#00BFFF',
          data: { ...item, ...(reservoir || {}) },
          entity,
        })
      })
      district.forEach(item => {
        let entity = drag.addPointEntity(item);
        this.poinEntity[item.id] = entity;
      })

      industrialPark.forEach(item => {
        let entity = drag.addPointEntity(item);
        this.poinEntity[item.id] = entity;
      })

      pumping.forEach(item => {
        let entity = drag.addPointEntity(item);
        this.poinEntity[item.id] = entity;
      })

      pool.forEach(item => {
        let entity = drag.addPointEntity(item);
        this.poinEntity[item.id] = entity;
      })

      irrigation.forEach(item => {
        let entity = drag.addPointEntity(item);
        this.poinEntity[item.id] = entity;
      })

      highTrunkLine.forEach(item => {
        this.buildPipe(item, window.viewer, Cesium.Color.RED)
      })

      channel.forEach(item => {
        this.buildPipe(item, window.viewer, Cesium.Color.BLUE)
      })

      BranchTrunkLine.forEach(item => {
        this.buildPipe(item, window.viewer, Cesium.Color.GREEN)
      })
    },

    bubble(id) {
      if (this.bubbles) {
        this.bubbles.windowClose()
      }
      this.bubbles = new Bubble(Object.assign(this.poinEntity[id], {
        viewer: window.viewer
      }))
    },

    buildPipe(item, viewer, color) {
      const PolylineGeometry = new Cesium.PolylineGeometry({
        positions: Cesium.Cartesian3.fromDegreesArrayHeights(item.location),
        width: 4
      })
      const instance = new Cesium.GeometryInstance({
        id: {
          id: item.id,
          categories: item.categories
        },
        geometry: PolylineGeometry,
        attributes: {
          distanceDisplayCondition: new Cesium.DistanceDisplayConditionGeometryInstanceAttribute(
              100000.0,
              Number.POSITIVE_INFINITY
          )
        }
      });
      const appearance = getFlylineMaterial(color);

      const primitive = viewer.scene.primitives.add(
          new Cesium.Primitive({
            geometryInstances: [instance],
            appearance: appearance,
            depthFailAppearance: appearance,
            releaseGeometryInstances: false,
            compressVertices: false,
          }),
      );

      this.pipeObj.push(primitive);
    },

    /**
     * 获取洪水方案数据（从 prolusion 组件或默认数据）
     */
    _getFloodSchemeData(schemeNum) {
      // 默认方案数据（与 SmartOrb.vue 中 FLOOD_SCHEME_EXPERTISE 保持一致）
      const schemes = {
        1: {
          name: '下泄方案1', inundationArea: 1.8, peakTime: '第10小时',
          timeline: { time: ['0h','2h','4h','6h','8h','10h','12h','16h','20h','24h'], area: [0.2,0.4,0.7,1.0,1.5,1.8,1.6,1.1,0.6,0.3] }
        },
        2: {
          name: '下泄方案2', inundationArea: 2.4, peakTime: '第9小时',
          timeline: { time: ['0h','2h','4h','6h','8h','10h','12h','16h','20h','24h'], area: [0.3,0.6,1.0,1.5,2.1,2.4,2.0,1.3,0.8,0.4] }
        },
        3: {
          name: '下泄方案3', inundationArea: 3.6, peakTime: '第8小时',
          timeline: { time: ['0h','2h','4h','6h','8h','10h','12h','16h','20h','24h'], area: [0.5,0.9,1.6,2.7,3.6,3.3,2.6,1.7,1.0,0.5] }
        },
      }
      return schemes[schemeNum] || schemes[2]
    },

    /**
     * 启动3D洪水淹没动画
     * 在Cesium地球上动态展示淹没范围随时间扩展和收缩
     * @param {Object} schemeData - 方案数据，包含 timeline
     */
    startFloodInundationAnimation(schemeData) {
      this.stopFloodInundationAnimation()
      const viewer = this.getCesiumViewer()
      if (!viewer || !Cesium) return

      const timeline = schemeData.timeline
      if (!timeline || !timeline.time || !timeline.area) return

      // 淹没区域中心坐标（龙门镇黄河河道区域）
      const centerLng = 110.352
      const centerLat = 35.500
      // 最大淹没面积（用于归一化水面高度）
      const maxArea = Math.max(...timeline.area)

      this._floodAnimEntities = []
      this._floodAnimFrameIndex = 0
      this._floodAnimTotalFrames = timeline.time.length

      // 创建水面材质
      const waterMaterial = new Cesium.ImageMaterialProperty({
        image: require('@/assets/waterNormals.jpg'),
        repeat: new Cesium.Cartesian2(3, 3),
        color: new Cesium.Color(37/255, 158/255, 101/255, 0.65),
      })

      // 创建淹没多边形实体（动态半径）
      const self = this
      const floodPolygon = viewer.entities.add({
        id: 'flood-anim-polygon',
        name: '洪水淹没范围',
        polygon: {
          hierarchy: new Cesium.CallbackProperty(() => {
            const frameIdx = self._floodAnimFrameIndex % self._floodAnimTotalFrames
            const area = timeline.area[frameIdx]
            const radiusKm = Math.sqrt(Math.max(0.01, area) / Math.PI)
            const radiusDeg = radiusKm / 111
            const positions = self._generateFloodPolygonPositions(centerLng, centerLat, radiusDeg)
            return new Cesium.PolygonHierarchy(Cesium.Cartesian3.fromDegreesArray(positions))
          }, false),
          material: waterMaterial,
          height: 0,
          extrudedHeight: new Cesium.CallbackProperty(() => {
            const frameIdx = self._floodAnimFrameIndex % self._floodAnimTotalFrames
            const area = timeline.area[frameIdx]
            // 水面高度随面积变化（450m~465m）
            return 450 + (area / maxArea) * 15
          }, false),
          perPositionHeight: false,
        },
      })
      this._floodAnimEntities.push(floodPolygon)

      // 创建淹没边界线
      const floodOutline = viewer.entities.add({
        id: 'flood-anim-outline',
        name: '淹没边界',
        polyline: {
          positions: new Cesium.CallbackProperty(() => {
            const frameIdx = self._floodAnimFrameIndex % self._floodAnimTotalFrames
            const area = timeline.area[frameIdx]
            const radiusKm = Math.sqrt(Math.max(0.01, area) / Math.PI)
            const radiusDeg = radiusKm / 111
            const positions = self._generateFloodPolygonPositions(centerLng, centerLat, radiusDeg)
            return Cesium.Cartesian3.fromDegreesArray(positions)
          }, false),
          width: 3,
          material: new Cesium.PolylineGlowMaterialProperty({
            glowPower: 0.25,
            color: Cesium.Color.fromCssColorString('#ff6b35').withAlpha(0.85),
          }),
          clampToGround: true,
        },
      })
      this._floodAnimEntities.push(floodOutline)

      // 创建时间进度标签
      const floodLabel = viewer.entities.add({
        id: 'flood-anim-label',
        name: '洪水演进时间',
        position: Cesium.Cartesian3.fromDegrees(centerLng, centerLat + 0.02, 500),
        label: {
          text: new Cesium.CallbackProperty(() => {
            const frameIdx = self._floodAnimFrameIndex % self._floodAnimTotalFrames
            const time = timeline.time[frameIdx]
            const area = timeline.area[frameIdx]
            return `${time} | 淹没 ${area.toFixed(1)} km²`
          }, false),
          font: 'bold 20px sans-serif',
          fillColor: Cesium.Color.fromCssColorString('#ff6b35'),
          outlineColor: Cesium.Color.BLACK,
          outlineWidth: 4,
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          pixelOffset: new Cesium.Cartesian2(0, -40),
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 50000),
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
          showBackground: true,
          backgroundColor: Cesium.Color.fromCssColorString('rgba(8,18,32,0.82)'),
          backgroundPadding: new Cesium.Cartesian2(12, 8),
        },
      })
      this._floodAnimEntities.push(floodLabel)

      // 启动动画定时器（每1.5秒推进一帧，10帧共15秒循环）
      this._floodAnimTimer = window.setInterval(() => {
        self._floodAnimFrameIndex += 1
        // 循环播放
        if (self._floodAnimFrameIndex >= self._floodAnimTotalFrames * 2) {
          self._floodAnimFrameIndex = 0
        }
      }, 1500)

      // 飞行到淹没区域上空（低空倾斜视角）
      const alt = 2500
      const pitch = -0.55
      const heading = 0.3
      const offset = alt / Math.tan(Math.abs(pitch))
      const camLat = centerLat - (offset * Math.cos(heading)) / 111320
      const camLng = centerLng - (offset * Math.sin(heading)) / (111320 * Math.cos(centerLat * Math.PI / 180))
      viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(camLng, camLat, alt),
        orientation: { heading, pitch, roll: 0 },
        duration: 2,
      })
    },

    /**
     * 生成淹没多边形顶点坐标数组（不规则多边形模拟河道淹没形状）
     */
    _generateFloodPolygonPositions(centerLng, centerLat, radiusDeg) {
      // 沿河道方向（东北-西南）拉伸的椭圆形淹没区域
      const points = []
      const segments = 24
      const stretchX = 1.8  // 沿河道方向拉伸
      const stretchY = 0.7  // 垂直河道方向压缩
      for (let i = 0; i < segments; i++) {
        const angle = (i / segments) * Math.PI * 2
        const x = centerLng + Math.cos(angle) * radiusDeg * stretchX
        const y = centerLat + Math.sin(angle) * radiusDeg * stretchY
        points.push(x, y)
      }
      return points
    },

    /**
     * 停止3D洪水淹没动画并清理实体
     */
    stopFloodInundationAnimation() {
      if (this._floodAnimTimer) {
        window.clearInterval(this._floodAnimTimer)
        this._floodAnimTimer = null
      }
      const viewer = this.getCesiumViewer()
      if (viewer && this._floodAnimEntities) {
        this._floodAnimEntities.forEach(entity => {
          if (entity) viewer.entities.remove(entity)
        })
      }
      this._floodAnimEntities = []
      this._floodAnimFrameIndex = 0
    },

    /**
     * 启动应急面板的龙门镇洪水演进动画
     * 复用与 startFloodInundationAnimation 相同的机制，但使用 EMERGENCY_GIS_DATA 中的配置
     * @param {Object} config - floodAnimation 配置
     */
    startEmergencyFloodAnimation(config) {
      this.stopEmergencyFloodAnimation()
      const viewer = this.getCesiumViewer()
      if (!viewer || !Cesium) return

      const timeline = config.timeline
      if (!timeline || !timeline.time || !timeline.area) return

      const centerLng = config.centerLng
      const centerLat = config.centerLat
      const maxArea = Math.max(...timeline.area)
      const stretchX = config.stretchX || 1.8
      const stretchY = config.stretchY || 0.7
      const heightMin = config.heightMin || 378
      const heightMax = config.heightMax || 388

      this._emergFloodEntities = []
      this._emergFloodFrameIndex = 0
      this._emergFloodTotalFrames = timeline.time.length

      // 创建水面材质
      const waterMaterial = new Cesium.ImageMaterialProperty({
        image: require('@/assets/waterNormals.jpg'),
        repeat: new Cesium.Cartesian2(3, 3),
        color: new Cesium.Color(37 / 255, 158 / 255, 101 / 255, 0.65),
      })

      const self = this

      // 生成椭圆形多边形顶点
      const generatePositions = (radiusDeg) => {
        const points = []
        const segments = 24
        for (let i = 0; i < segments; i++) {
          const angle = (i / segments) * Math.PI * 2
          const x = centerLng + Math.cos(angle) * radiusDeg * stretchX
          const y = centerLat + Math.sin(angle) * radiusDeg * stretchY
          points.push(x, y)
        }
        return points
      }

      // 淹没水面多边形
      const floodPolygon = viewer.entities.add({
        id: 'emerg-flood-polygon',
        name: '龙门镇洪水淹没范围',
        polygon: {
          hierarchy: new Cesium.CallbackProperty(() => {
            const frameIdx = self._emergFloodFrameIndex % self._emergFloodTotalFrames
            const area = timeline.area[frameIdx]
            const radiusKm = Math.sqrt(Math.max(0.01, area) / Math.PI)
            const radiusDeg = radiusKm / 111
            return new Cesium.PolygonHierarchy(Cesium.Cartesian3.fromDegreesArray(generatePositions(radiusDeg)))
          }, false),
          material: waterMaterial,
          height: 0,
          extrudedHeight: new Cesium.CallbackProperty(() => {
            const frameIdx = self._emergFloodFrameIndex % self._emergFloodTotalFrames
            const area = timeline.area[frameIdx]
            return heightMin + (area / maxArea) * (heightMax - heightMin)
          }, false),
          perPositionHeight: false,
        },
      })
      this._emergFloodEntities.push(floodPolygon)

      // 淹没边界线
      const floodOutline = viewer.entities.add({
        id: 'emerg-flood-outline',
        name: '淹没边界',
        polyline: {
          positions: new Cesium.CallbackProperty(() => {
            const frameIdx = self._emergFloodFrameIndex % self._emergFloodTotalFrames
            const area = timeline.area[frameIdx]
            const radiusKm = Math.sqrt(Math.max(0.01, area) / Math.PI)
            const radiusDeg = radiusKm / 111
            return Cesium.Cartesian3.fromDegreesArray(generatePositions(radiusDeg))
          }, false),
          width: 3,
          material: new Cesium.PolylineGlowMaterialProperty({
            glowPower: 0.25,
            color: Cesium.Color.fromCssColorString('#ff6b35').withAlpha(0.85),
          }),
          clampToGround: true,
        },
      })
      this._emergFloodEntities.push(floodOutline)

      // 时间进度标签
      const floodLabel = viewer.entities.add({
        id: 'emerg-flood-label',
        name: '洪水演进时间',
        position: Cesium.Cartesian3.fromDegrees(centerLng, centerLat + 0.015, 480),
        label: {
          text: new Cesium.CallbackProperty(() => {
            const frameIdx = self._emergFloodFrameIndex % self._emergFloodTotalFrames
            const time = timeline.time[frameIdx]
            const area = timeline.area[frameIdx]
            return `${time} | 淹没 ${area.toFixed(1)} km²`
          }, false),
          font: 'bold 20px sans-serif',
          fillColor: Cesium.Color.fromCssColorString('#ff6b35'),
          outlineColor: Cesium.Color.BLACK,
          outlineWidth: 4,
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          pixelOffset: new Cesium.Cartesian2(0, -40),
          distanceDisplayCondition: new Cesium.DistanceDisplayCondition(0, 50000),
          disableDepthTestDistance: Number.POSITIVE_INFINITY,
          showBackground: true,
          backgroundColor: Cesium.Color.fromCssColorString('rgba(8,18,32,0.82)'),
          backgroundPadding: new Cesium.Cartesian2(12, 8),
        },
      })
      this._emergFloodEntities.push(floodLabel)

      // 启动动画定时器
      this._emergFloodTimer = window.setInterval(() => {
        self._emergFloodFrameIndex += 1
        if (self._emergFloodFrameIndex >= self._emergFloodTotalFrames * 2) {
          self._emergFloodFrameIndex = 0
        }
      }, 1500)
    },

    /**
     * 停止应急面板洪水演进动画
     */
    stopEmergencyFloodAnimation() {
      if (this._emergFloodTimer) {
        window.clearInterval(this._emergFloodTimer)
        this._emergFloodTimer = null
      }
      const viewer = this.getCesiumViewer()
      if (viewer && this._emergFloodEntities) {
        this._emergFloodEntities.forEach(entity => {
          if (entity) viewer.entities.remove(entity)
        })
      }
      this._emergFloodEntities = []
      this._emergFloodFrameIndex = 0
    },
  }
}
</script>

<style scoped>
/* 样式保持不变 */
.panel-host {
  position: fixed;
  z-index: 10005;
  pointer-events: none;
  box-sizing: border-box;
}

.panel-host .managed-panel {
  position: relative !important;
  z-index: 1;
  inset: auto !important;
  left: auto !important;
  right: auto !important;
  top: auto !important;
  bottom: auto !important;
  transform: none !important;
  width: 100% !important;
  max-width: 100% !important;
  height: 100% !important;
  max-height: 100% !important;
  overflow: auto !important;
  box-sizing: border-box !important;
  pointer-events: auto;
}

.panel-host /deep/ .border,
.panel-host /deep/ .backGround,
.panel-host /deep/ .innerbox,
.panel-host /deep/ .supply-demand-panel,
.panel-host /deep/ .storyline-guide {
  box-sizing: border-box;
}

.panel-host /deep/ .border {
  width: 100% !important;
  max-width: 100% !important;
  height: 100% !important;
  max-height: 100% !important;
  overflow: auto;
  /* ── 统一面板主题：对齐演示导览风格 ── */
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94)) !important;
  border: 1px solid rgba(99, 179, 237, 0.28) !important;
  border-radius: 10px !important;
  box-shadow: 0 18px 52px rgba(0, 0, 0, 0.42) !important;
  color: #eef7ff !important;
}

/* ── 统一面板内所有按钮样式 ── */
.panel-host /deep/ .border button,
.panel-host /deep/ .backGround button,
.panel-host /deep/ .innerbox button,
.panel-host /deep/ .collapsed-btn,
.panel-host /deep/ .gis-jump-btn {
  height: 28px;
  padding: 0 12px;
  border-radius: 7px;
  border: 1px solid rgba(56, 189, 248, 0.32);
  background: rgba(56, 189, 248, 0.12);
  color: #b8ecff;
  cursor: pointer;
  white-space: nowrap;
  font-size: 12px;
  transition: background 0.2s, border-color 0.2s;
}

.panel-host /deep/ .border button:hover,
.panel-host /deep/ .backGround button:hover,
.panel-host /deep/ .innerbox button:hover,
.panel-host /deep/ .collapsed-btn:hover,
.panel-host /deep/ .gis-jump-btn:hover {
  background: rgba(56, 189, 248, 0.22);
  border-color: rgba(56, 189, 248, 0.48);
}

/* ── 统一关闭/折叠按钮 ── */
.panel-host /deep/ .border .close,
.panel-host /deep/ .backGround .close {
  width: 30px;
  height: 30px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.72);
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
}

.panel-host /deep/ .border .close:hover,
.panel-host /deep/ .backGround .close:hover {
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.28);
}

/* ── 统一卡片标题样式 ── */
.panel-host /deep/ .border .card-title,
.panel-host /deep/ .backGround .card-title {
  text-align: center;
  color: #fff;
  font-size: 18px;
  margin: 4px 0 10px;
}

/* ── 统一分区标题 ── */
.panel-host /deep/ .border .section-title,
.panel-host /deep/ .backGround .section-title,
.panel-host /deep/ .innerbox .section-title {
  color: #fff;
  font-size: 14px;
  margin-bottom: 10px;
}

/* ── 统一状态条 ── */
.panel-host /deep/ .border .status-strip {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 7px;
  background: rgba(56, 189, 248, 0.08);
  border: 1px solid rgba(56, 189, 248, 0.16);
  margin-bottom: 12px;
  font-size: 12px;
}

.panel-host /deep/ .border .status-strip strong {
  color: #b8ecff;
}

/* ── 统一折叠状态条 ── */
.panel-host /deep/ .collapsed-bar {
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94)) !important;
  border: 1px solid rgba(99, 179, 237, 0.28) !important;
  border-radius: 10px !important;
}

/* ── 统一进度条样式（如果面板中使用了 .progress-bar） ── */
.panel-host /deep/ .progress-bar {
  height: 5px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  overflow: hidden;
}

.panel-host /deep/ .progress-bar span,
.panel-host /deep/ .progress-bar > div {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #38bdf8, #34d399);
}

/* ── 统一卡片背景 ── */
.panel-host /deep/ .border .gis-detail-card,
.panel-host /deep/ .border .detail-card,
.panel-host /deep/ .innerbox .detail-card {
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.045);
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 12px;
}

/* ── 统一 supply-demand-panel 根容器 ── */
.panel-host /deep/ .supply-demand-panel {
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94)) !important;
  border: 1px solid rgba(99, 179, 237, 0.28) !important;
  border-radius: 10px !important;
  box-shadow: 0 18px 52px rgba(0, 0, 0, 0.42) !important;
  color: #eef7ff !important;
}

/* ── 统一 submergAnalysis 根容器 ── */
.panel-host /deep/ .sub_ana_container {
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94)) !important;
  border: 1px solid rgba(99, 179, 237, 0.28) !important;
  border-radius: 10px !important;
  box-shadow: 0 18px 52px rgba(0, 0, 0, 0.42) !important;
  color: #eef7ff !important;
}

/* ── 统一 backGround + innerbox（custom.vue 等）── */
.panel-host /deep/ .backGround.innerbox {
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94)) !important;
  border: 1px solid rgba(99, 179, 237, 0.28) !important;
  border-radius: 10px !important;
  box-shadow: 0 18px 52px rgba(0, 0, 0, 0.42) !important;
  color: #eef7ff !important;
}

/* ── 统一 scheduling-shell 根容器 ── */
.panel-host /deep/ .scheduling-shell {
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94)) !important;
  border: 1px solid rgba(99, 179, 237, 0.28) !important;
  border-radius: 10px !important;
  color: #eef7ff !important;
}

.panel-layout-storyline {
  left: 50%;
  top: 50%;
  width: min(1040px, calc(100vw - 220px));
  height: min(700px, calc(100vh - 150px));
  transform: translate(-50%, -50%);
}

.panel-layout-flood {
  left: 24px;
  top: 92px;
  bottom: 34px;
  width: clamp(620px, 52vw, 720px);
}

.panel-layout-scheduling {
  right: 28px;
  top: 88px;
  bottom: 36px;
  width: min(1180px, calc(100vw - 500px));
  min-width: 760px;
}

.panel-layout-emergency {
  right: 28px;
  top: 88px;
  bottom: 36px;
  width: min(1040px, calc(100vw - 520px));
  min-width: 700px;
}

.panel-layout-knowledge {
  inset: 0;
  width: 100vw;
  height: 100vh;
  transform: none;
  z-index: 10020;
}

.panel-layout-storyline .managed-panel,
.panel-layout-flood .managed-panel,
.panel-layout-scheduling .managed-panel,
.panel-layout-emergency .managed-panel {
  border-radius: 12px;
  overflow: hidden !important;
}

.panel-layout-storyline .managed-panel {
  border-radius: 18px;
}

.panel-layout-knowledge .managed-panel {
  position: fixed !important;
  inset: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  overflow: visible !important;
  pointer-events: auto;
}

.panel-layout-flood /deep/ .scenario-panel,
.panel-layout-flood /deep/ .scheme-panel {
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94)) !important;
  border: 1px solid rgba(99, 179, 237, 0.28) !important;
  border-radius: 10px !important;
  box-shadow: 0 18px 52px rgba(0, 0, 0, 0.42) !important;
}

.panel-layout-storyline /deep/ .storyline-guide {
  background:
    linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94)) padding-box,
    conic-gradient(from 90deg, #ff4ecd, #7c3cff, #25d9ff, #40ffba, #f8ff59, #ff8a3d, #ff4ecd) border-box !important;
  border: 2px solid transparent !important;
  border-radius: 18px;
  box-shadow: 0 22px 70px rgba(0, 0, 0, 0.46), 0 0 34px rgba(124, 60, 255, 0.16);
}

.panel-layout-scheduling /deep/ .scheduling-shell,
.panel-layout-emergency /deep/ .orb-business-panel {
  border-radius: 12px;
}

.panel-layout-scheduling /deep/ .border,
.panel-layout-emergency /deep/ .border {
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94)) !important;
  border: 1px solid rgba(99, 179, 237, 0.28) !important;
  border-radius: 10px !important;
  box-shadow: 0 18px 52px rgba(0, 0, 0, 0.42) !important;
}

/* 应急面板折叠状态：高度自适应 */
.panel-layout-emergency:has(.collapsed-bar) {
  bottom: auto !important;
  height: auto !important;
}

.panel-layout-emergency:has(.collapsed-bar) .managed-panel {
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
}

.panel-layout-emergency /deep/ .collapsed-bar {
  border-radius: 12px;
}

.panel-layout-right-dock {
  right: 18px;
  top: 92px;
  bottom: 96px;
  width: clamp(340px, 25vw, 430px);
}

.panel-layout-right-dock .managed-panel,
.panel-layout-inspector .managed-panel,
.panel-layout-assistant .managed-panel,
.panel-layout-bottom-sheet .managed-panel {
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94));
  border: 1px solid rgba(99, 179, 237, 0.28);
  border-radius: 10px;
  backdrop-filter: blur(10px);
  box-shadow: 0 18px 52px rgba(0, 0, 0, 0.42);
}

.panel-layout-workbench {
  top: 92px;
  right: 18px;
  bottom: 28px;
  left: clamp(420px, 34vw, 560px);
}

.panel-layout-workbench .managed-panel {
  background: linear-gradient(135deg, rgba(8, 18, 32, 0.96), rgba(13, 38, 50, 0.94));
  border: 1px solid rgba(99, 179, 237, 0.28);
  border-radius: 10px;
  backdrop-filter: blur(8px);
  box-shadow: 0 18px 52px rgba(0, 0, 0, 0.42);
}

.panel-layout-inspector {
  top: 96px;
  right: 18px;
  width: clamp(360px, 32vw, 560px);
  max-height: calc(100vh - 170px);
}

.panel-layout-inspector .managed-panel {
  height: auto !important;
  min-height: 260px;
  max-height: calc(100vh - 170px) !important;
}

/* === 水库双面板布局：完全释放 managed-panel 约束 === */
/* 用 3 个 class 选择器提高优先级，压过 .panel-host .managed-panel */
.panel-host.panel-layout-reservoir-dual {
  top: 0 !important;
  left: 0 !important;
  right: auto !important;
  bottom: auto !important;
  width: 0 !important;
  height: 0 !important;
  overflow: visible !important;
  pointer-events: none !important;
}

.panel-host.panel-layout-reservoir-dual .managed-panel {
  position: static !important;
  width: 0 !important;
  height: 0 !important;
  max-width: none !important;
  max-height: none !important;
  overflow: visible !important;
  inset: auto !important;
  transform: none !important;
  pointer-events: none !important;
}

.panel-layout-bottom-sheet {
  left: clamp(360px, 24vw, 480px);
  right: clamp(130px, 14vw, 240px);
  bottom: 24px;
  height: min(520px, 56vh);
}

.panel-layout-bottom-sheet /deep/ .supply-demand-panel {
  background:
    linear-gradient(135deg, rgba(5, 18, 32, 0.95), rgba(11, 38, 48, 0.92)) padding-box,
    conic-gradient(from 90deg, #ff4ecd, #7c3cff, #25d9ff, #40ffba, #f8ff59, #ff8a3d, #ff4ecd) border-box !important;
  border: 2px solid transparent !important;
  border-radius: 16px !important;
  box-shadow: 0 18px 58px rgba(0, 0, 0, 0.42), 0 0 28px rgba(37, 217, 255, 0.14);
}

.panel-layout-assistant {
  left: 50%;
  top: 50%;
  width: min(1280px, calc(100vw - 96px));
  height: min(760px, calc(100vh - 128px));
  transform: translate(-50%, -50%);
  z-index: 10020;
}

.panel-layout-assistant .managed-panel {
  position: fixed !important;
  inset: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  overflow: visible !important;
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  backdrop-filter: none;
}

.submergence-floating-panel {
  position: fixed !important;
  top: auto !important;
  right: 18px !important;
  bottom: 114px !important;
  width: min(320px, calc(100vw - 36px)) !important;
  max-height: calc(100vh - 220px);
  overflow: auto;
  z-index: 9998;
  border-radius: 10px;
  backdrop-filter: blur(8px);
  box-shadow: 0 14px 40px rgba(0, 0, 0, 0.34);
}

.panel-layout-bottom-sheet /deep/ .sd-section {
  padding-top: 12px;
  padding-bottom: 12px;
}

.panel-layout-bottom-sheet /deep/ .sd-chart {
  height: 210px;
}

@media (max-width: 1280px) {
  .panel-layout-workbench,
  .panel-layout-storyline {
    left: 18px;
    right: 18px;
    top: 90px;
    bottom: 24px;
    width: auto;
    height: auto;
    transform: none;
  }

  .panel-layout-right-dock,
  .panel-layout-inspector {
    width: min(440px, calc(100vw - 36px));
  }

  .panel-layout-flood {
    left: 18px;
    right: auto;
    width: min(660px, calc(100vw - 36px));
  }

  .panel-layout-scheduling,
  .panel-layout-emergency {
    right: 18px;
    left: auto;
    width: min(940px, calc(100vw - 240px));
    min-width: 0;
  }

  .panel-layout-emergency {
    width: min(860px, calc(100vw - 300px));
  }

  .panel-layout-bottom-sheet {
    left: 18px;
    right: 18px;
  }

  .panel-layout-knowledge,
  .panel-layout-assistant {
    inset: 0;
    width: 100vw;
    height: 100vh;
    transform: none;
  }
}

@media (max-width: 760px) {
  .panel-host {
    left: 12px !important;
    right: 12px !important;
    top: 88px !important;
    bottom: 18px !important;
    width: auto !important;
    height: auto !important;
    max-height: none !important;
  }

  .panel-layout-inspector .managed-panel {
    height: 100% !important;
    max-height: 100% !important;
  }

  .submergence-floating-panel {
    left: 12px !important;
    right: 12px !important;
    bottom: 18px !important;
    width: auto !important;
  }
}

.top-buttons-container {
  position: absolute;
  top: 0;
  left: 80px;
  right: 0;
  height: 70px;
  z-index: 1000;
  display: flex;
  justify-content: space-between;
}

.left-buttons {
  display: flex;
  gap: 5px;
  position: absolute;
  left: 0;
}

.right-buttons {
  display: flex;
  gap: 5px;
  position: absolute;
  right: 270px;
}

.top-button {
  width: 160px;
  height: 60px;
  background-color: transparent;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  border: none;
  color: white;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  transition: all 0.3s ease;
}

.top-button:hover {
  filter: brightness(1.2);
  transform: translateY(-2px);
}

/* AI助手容器样式 */
.ai-assistant-container {
  position: fixed;
  bottom: 85px;
  right: 23.75%;
  z-index: 10500;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.ai-dropdown-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 25px;
  color: white;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.2);
  transition: all 0.3s ease;
  min-width: 145px;
  backdrop-filter: blur(10px);
  border: 2px solid rgba(149, 128, 238, 0.2);
  animation: pulse-glow 3s infinite;
}

.ai-dropdown-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.3);
  background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
  border-color: rgba(149, 128, 238, 0.4);
  animation: none;
}

@keyframes pulse-glow {
  0%, 100% {
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.2);
  }
  50% {
    box-shadow: 0 4px 20px rgba(157, 112, 245, 0.4);
  }
}

.ai-icon {
  font-size: 20px;
}

.ai-text {
  flex: 1;
  text-align: center;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.dropdown-indicator {
  font-size: 12px;
  color: rgba(227, 217, 251, 0.8);
  transition: transform 0.3s ease;
  margin-top: 2px;
}

.ai-assistant-menu {
  position: absolute;
  bottom: 100%;
  right: 0;
  min-width: 280px;
  background: rgba(20, 30, 60, 0.9);
  border: 1px solid rgba(102, 126, 234, 0.3);
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  z-index: 10499;
  overflow: hidden;
  margin-bottom: 10px;
  animation: menu-appear 0.3s ease;
  padding: 10px 0;
  transform: translateY(0) scale(1);
  opacity: 1;
}

@keyframes menu-appear {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.assistant-option {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: rgb(204, 218, 253);
  font-size: 14px;
  background: linear-gradient(to right, rgba(66, 146, 241, 0.1), rgba(130, 159, 254, 0.1));
  margin: 5px 10px;
  border-radius: 8px;
}

.assistant-option:last-child {
  border-bottom: none;
}

.assistant-option:hover {
  background: rgba(86, 169, 235, 0.2);
  border-left-color: rgb(170, 214, 231);
  color: rgb(255, 255, 255);
  transform: translateX(-5px);
  box-shadow: 0 4px 15px rgba(80, 162, 223, 0.3);
  border-radius: 8px;
  border: 1px solid rgba(181, 215, 222, 0.3);
}

.assistant-option.active {
  background: rgba(62, 210, 203, 0.2);
  border-left-color: rgb(101, 207, 203);
  color: rgb(200, 255, 250);
  box-shadow: 0 4px 15px rgba(62, 210, 203, 0.3);
  transform: translateX(-5px);
  border-radius: 8px;
  border: 1px solid rgba(101, 207, 203, 0.4);
}

.option-icon {
  font-size: 20px;
  width: 24px;
  text-align: center;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.option-text {
  flex: 1;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.5px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.option-desc {
  font-size: 12px;
  color: rgba(200, 220, 255, 0.7);
  white-space: nowrap;
  background: rgba(0, 0, 0, 0.2);
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

/* 原chatbot按钮样式 */
.chatbot {
  position: fixed;
  bottom: 20px;
  right: 25%;
  background: linear-gradient(135deg, #4085e9, #00dda6);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: none;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 10000;
  transition: all 0.3s ease;
}

.chatbot:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  background: linear-gradient(135deg, #00dda6, #4085e9);
}

/* 头部样式 */
.header {
  background: url("../assets/header.png");
  background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
  height: 80px;
  position: fixed;
  z-index: 9999;
  left: 0;
  top: 0;
  text-align: center;
}

.header-info-container {
  position: absolute;
  top: 10px;
  right: 20px;
  z-index: 10000;
}

#cesiumContainer {
  height: 100vh;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

/deep/ .el-input__inner {
  background-color: rgba(255, 255, 255, 0.247);
  border: 1px solid rgba(99, 179, 237, 0.48);
  color: #76d9ff;
  border-radius: 4px;
}

/deep/ .el-form-item {
  background-color: unset !important;
}

.bottom-dock {
  position: fixed;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%);
  max-width: calc(100vw - 220px);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 10px;
  z-index: 9996;
  pointer-events: none;
}

.bottom-button {
  position: static;
  transform: none;
  padding: 12px 18px;
  width: 160px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: rgba(20, 40, 80, 0.45);
  backdrop-filter: blur(6px);
  border: 1px solid rgba(99, 179, 237, 0.4);
  border-radius: 12px;
  box-shadow: 0 0 8px rgba(56, 189, 248, 0.5),
  inset 0 0 10px rgba(56, 189, 248, 0.2);
  transition: all 0.25s ease;
  pointer-events: auto;
}

.bottom-button span {
  margin-left: 10px;
  color: #76d9ff;
  font-size: 16px;
  font-family: "Orbitron", sans-serif;
  letter-spacing: 1px;
}

.bottom-button:hover {
  transform: translateY(-3px) scale(1.03);
  box-shadow: 0 0 15px rgba(56, 189, 248, 0.7),
  inset 0 0 15px rgba(56, 189, 248, 0.35);
  border-color: rgba(56, 189, 248, 0.7);
}

.bottom-button:active {
  transform: scale(0.98);
  box-shadow: 0 0 8px rgba(56, 189, 248, 0.5),
  inset 0 0 8px rgba(56, 189, 248, 0.4);
}

@media (max-width: 900px) {
  .bottom-dock {
    left: 18px;
    right: 18px;
    bottom: 20px;
    transform: none;
    max-width: none;
  }

  .bottom-button {
    width: 112px;
    padding: 10px 8px;
  }

  .bottom-button span {
    margin-left: 0 !important;
    font-size: 12px !important;
  }
}

@media (max-width: 900px) {
  .top-buttons-container {
    left: 12px;
    right: 12px;
    height: 54px;
    justify-content: center;
    gap: 4px;
    pointer-events: none;
  }

  .left-buttons,
  .right-buttons {
    position: static;
    gap: 4px;
    pointer-events: auto;
  }

  .top-button {
    width: 112px;
    height: 42px;
    font-size: 12px;
  }

  .header-info-container {
    display: none;
  }
}

/* Task execution is a viewport overlay, not a docked business panel. */
.panel-layout-task-execution {
  inset: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  transform: none !important;
  z-index: 10050 !important;
  pointer-events: none;
}

.panel-layout-task-execution .managed-panel {
  position: fixed !important;
  inset: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  max-width: none !important;
  max-height: none !important;
  overflow: visible !important;
  pointer-events: auto;
}

@media (max-width: 1400px) {
  .header {
    height: 112px;
    background-size: 100% 112px;
  }

  .top-buttons-container {
    top: 58px;
    left: 12px;
    right: 12px;
    height: 48px;
    justify-content: center;
    gap: 4px;
    pointer-events: none;
  }

  .left-buttons,
  .right-buttons {
    position: static;
    gap: 4px;
    pointer-events: auto;
  }

  .top-button {
    width: clamp(92px, 17vw, 120px);
    height: 44px;
    font-size: 12px;
  }
}
</style>
